/* Bakaliko wholesale page (plan 5.4, WS-1..WS-10). Plain JavaScript, no build step.
   Data comes from the wholesale core through the app proxy (/apps/wholesale/*) for the
   logged-in customer only; the core checks every change again. Texts are the wholesale.*
   locale keys, handed over by the sections as JSON ([name] placeholders are filled here). */
(function () {
  'use strict';

  // ------------------------------------------------------------------ shared ---
  function esc(v) {
    return String(v == null ? '' : v).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function fill(s, vars) {
    return String(s == null ? '' : s).replace(/\[(\w+)\]/g, function (m, n) { return vars && n in vars ? vars[n] : m; });
  }
  function config(id) {
    try { return JSON.parse(document.getElementById(id).textContent); } catch (e) { return { text: {} }; }
  }
  function timeoutSignal(ms) {
    if (window.AbortSignal && AbortSignal.timeout) return AbortSignal.timeout(ms);
    if (!window.AbortController) return undefined;
    var c = new AbortController();
    setTimeout(function () { c.abort(); }, ms);
    return c.signal;
  }
  // No answer (offline, timed out): an Error with .network, never the browser's own English text.
  // started: a request already on its way for this call (the section starts the first bootstrap).
  async function call(base, path, locale, body, keepalive, ms, started) {
    var url = base + '/' + path + (path.indexOf('?') >= 0 ? '&' : '?') + 'locale=' + locale;
    var r, j = null;
    try {
      r = await (started || fetch(url, {
        method: body ? 'POST' : 'GET', credentials: 'same-origin', keepalive: !!keepalive,
        headers: body ? { 'Content-Type': 'application/json', Accept: 'application/json' } : { Accept: 'application/json' },
        body: body ? JSON.stringify(body) : undefined, signal: timeoutSignal(ms || 30000),
      }));
      try { j = await r.json(); } catch (e) { if (e && e.name !== 'SyntaxError') throw e; j = null; }
    } catch (e) {
      var err = new Error('network');
      err.network = true;
      throw err;
    }
    return { status: r.status, ok: r.ok, body: j };
  }
  var ICON = {
    search: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="M20 20l-4-4"/></svg>',
    scan: '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M4 8V5h3M17 5h3v3M20 16v3h-3M7 19H4v-3"/><path d="M8 9v6M11 9v6M14 9v6M17 9v6"/></svg>',
    truck: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 7h11v9H3z"/><path d="M14 10h4l3 3v3h-7"/><circle cx="7" cy="17.5" r="1.6"/><circle cx="17" cy="17.5" r="1.6"/></svg>',
    clock: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>',
    repeat: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 12a9 9 0 1 0 3-6.7"/><path d="M3 4v5h5"/></svg>',
    back: '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg>',
    down: '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg>',
    close: '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>',
    cart: '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 4h2l2.4 11.2a1 1 0 0 0 1 .8h9.7a1 1 0 0 0 1-.8L21 8H6"/><circle cx="9.5" cy="20" r="1.4"/><circle cx="17.5" cy="20" r="1.4"/></svg>',
    person: '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><circle cx="12" cy="8" r="4"/><path d="M4 21a8 8 0 0 1 16 0"/></svg>',
    check: '<svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12l5 5 9-10"/></svg>',
    phone: '<svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="6" y="2" width="12" height="20" rx="2.5"/><path d="M10 18.5h4"/></svg>',
    share: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 15V3M8 7l4-4 4 4M5 12v8h14v-8"/></svg>',
    invoice: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M4 4h16v16H4z"/><path d="M8 9h8M8 13h8M8 17h5"/></svg>',
    mark: function (on) { return '<svg width="20" height="20" viewBox="0 0 24 24" fill="' + (on ? 'currentColor' : 'none') + '" stroke="currentColor" stroke-width="2" stroke-linejoin="round" aria-hidden="true"><path d="M6 3h12v18l-6-4-6 4z"/></svg>'; },
    tab: {
      list: 'M8 6h13M8 12h13M8 18h13M3.5 6h.01M3.5 12h.01M3.5 18h.01',
      catalogue: 'M3 3h7v7H3zM14 3h7v7h-7zM3 14h7v7H3zM14 14h7v7h-7z',
      orders: 'M6 2h9l5 5v15H6zM14 2v6h6M9 13h8M9 17h6',
      account: 'M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM4 21a8 8 0 0 1 16 0',
    },
  };

  // ------------------------------------------------------------------ signup ---
  // CU-2/CU-3: every field required; the core checks again and answers per field.
  function initSignup(el) {
    var T = config('wsl-signup-config').text || {};
    var base = el.dataset.proxy, locale = el.dataset.locale === 'nl' ? 'nl' : 'en';
    var form = el.querySelector('form'), msg = form.querySelector('.wsl-form__msg'), btn = form.querySelector('button[type=submit]');
    var NAMES = ['firstName', 'lastName', 'email', 'address1', 'zip', 'city', 'company', 'phone', 'vatNumber', 'kvkNumber'];
    var FORMAT = { email: 'signup.bad_email', zip: 'signup.bad_zip', phone: 'signup.bad_phone', vatNumber: 'signup.bad_vat', kvkNumber: 'signup.bad_kvk' };
    function setErr(name, text) {
      var e = el.querySelector('#wsl-e-' + name), i = el.querySelector('#wsl-f-' + name);
      if (e) e.textContent = text || '';
      if (i) i.setAttribute('aria-invalid', text ? 'true' : 'false');
    }
    // The signup check (Cloudflare Turnstile), shown when the core asks for it (owner, 2026-10-06).
    // Without it the core refuses the form and the message says so.
    var captcha = null;
    (async function () {
      try {
        var st = await call(base, 'state', locale);
        var key = st.body && st.body.captcha;
        if (!key) return;
        await new Promise(function (resolve, reject) {
          if (window.turnstile) return resolve();
          var s = document.createElement('script');
          s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
          s.async = true; s.onload = resolve; s.onerror = reject;
          document.head.appendChild(s);
        });
        var box = document.createElement('div');
        box.className = 'wsl-captcha';
        btn.parentNode.insertBefore(box, btn);
        captcha = window.turnstile.render(box, { sitekey: key, language: locale, action: 'signup' });
      } catch (e) { /* no check shown: the core refuses the form and says so */ }
    })();
    form.addEventListener('submit', async function (ev) {
      ev.preventDefault();
      var data = {};
      new FormData(form).forEach(function (v, k) { data[k] = String(v); });
      data.acceptTerms = form.querySelector('#wsl-f-acceptTerms').checked;
      data.termsUrl = el.dataset.terms || '';
      if (captcha !== null && window.turnstile) data.captchaToken = window.turnstile.getResponse(captcha) || '';
      NAMES.concat(['acceptTerms']).forEach(function (n) { setErr(n, ''); });
      msg.textContent = ''; msg.className = 'wsl-form__msg';
      var first = null;
      NAMES.forEach(function (n) { if (!String(data[n] || '').trim()) { setErr(n, T['signup.required']); first = first || n; } });
      if (!data.acceptTerms) { setErr('acceptTerms', T['signup.accept']); first = first || 'acceptTerms'; }
      if (first) { el.querySelector('#wsl-f-' + first).focus(); return; }
      btn.disabled = true; btn.textContent = T['signup.sending'];
      try {
        var r = await call(base, 'signup', locale, data);
        var b = r.body || {};
        if (r.ok && b.ok) {
          form.innerHTML = '<p class="wsl-form__msg wsl-form__msg--ok" role="status">' + esc(T['signup.done']) + '</p>';
          return;
        }
        var focus = null, unshown = false;
        Object.keys(b.errors || {}).forEach(function (k) {
          if (!el.querySelector('#wsl-f-' + k)) { unshown = true; return; } // e.g. the terms link setting
          var v = String(b.errors[k] || '');
          var text = v.indexOf('required') === 0 ? T['signup.required']
            : k === 'acceptTerms' ? T['signup.accept']
            : k === 'email' && /account/i.test(v) ? T['signup.one_account']
            : k === 'phone' && /cannot be used/i.test(v) ? T['signup.phone_taken']
            : T[FORMAT[k]] || T['errors.generic'];
          setErr(k, text);
          focus = focus || k;
        });
        if (focus && el.querySelector('#wsl-f-' + focus)) el.querySelector('#wsl-f-' + focus).focus();
        if (!focus || unshown) {
          msg.className = 'wsl-form__msg wsl-form__msg--bad';
          msg.textContent = r.status === 429 ? T['errors.too_many'] : T['signup.' + b.code] || T['errors.generic'];
        }
        // a token is good for one check: a new one for the next try
        if (captcha !== null && window.turnstile) window.turnstile.reset(captcha);
      } catch (e) {
        msg.className = 'wsl-form__msg wsl-form__msg--bad';
        msg.textContent = (e.network && T['errors.network']) || T['errors.generic'];
      } finally {
        btn.disabled = false; btn.textContent = T['signup.submit'];
      }
    });
  }

  // --------------------------------------------------------------------- app ---
  function initApp(root) {
    var CFG = config('wsl-config');
    var T = CFG.text || {};
    var base = root.dataset.proxy, LOC = root.dataset.locale === 'nl' ? 'nl' : 'en';
    var TAG = LOC === 'nl' ? 'nl-NL' : 'en-GB';
    function t(k, vars) { return fill(T[k] == null ? k : T[k], vars); }
    var money = new Intl.NumberFormat(TAG, { style: 'currency', currency: 'EUR' });
    function eur(c) { return money.format((c || 0) / 100); }
    function day(iso, long) {
      return new Date(iso + 'T12:00:00Z').toLocaleDateString(TAG, long ? { weekday: 'long', day: 'numeric', month: 'long', timeZone: 'UTC' } : { weekday: 'short', day: 'numeric', month: 'short', timeZone: 'UTC' });
    }

    var S = {
      b: null, items: new Map(), basket: new Map(), saved: new Map(), timers: new Map(), inflight: new Map(), unit: new Map(),
      screen: 'list', temp: 'all', listAisle: null, q: '', catQ: '', aisle: null, catShown: 60, cat: null, catLoading: null,
      orders: null, key: null, errors: null, done: null, placing: false, flash: null, marking: new Set(), loadedAt: 0, loadedDay: '',
      hideOut: true,
    };
    // Sold out products hidden or shown: the customer's switch, kept on this device; hidden until switched off
    var HIDE_STORE = 'wsl-hide-sold-out';
    try { S.hideOut = localStorage.getItem(HIDE_STORE) !== '0'; } catch (e) { /* storage blocked: hidden */ }

    // The core answers refusals in English; the page shows them in the shopper's language.
    var KNOWN = [[/delivery date/i, 'errors.date'], [/at most 200/i, 'errors.lines'], [/not a wholesale customer|not your order/i, 'errors.login'],
      [/not in the wholesale assortment|could not add|nothing to add/i, 'errors.not_found']];
    function translated(msg) {
      for (var i = 0; i < KNOWN.length; i++) if (KNOWN[i][0].test(msg || '')) return KNOWN[i][1];
      return 'errors.generic';
    }
    function failure(key) { var e = new Error(t(key)); e.key = key; return e; }
    async function api(path, body, keepalive, started) {
      var r;
      try { r = await call(base, path, LOC, body, keepalive, 0, started); } catch (e) { throw failure('errors.network'); }
      if (r.status === 429) throw failure('errors.too_many');
      if (r.status === 401) throw failure('errors.login');
      if (!r.body) throw failure('errors.generic');
      if (!r.ok && r.body.ok !== false) throw failure(translated(r.body.error));
      return r.body;
    }

    // -------------------------------------------------------------- the data ---
    // first: take over the request the section started before this script arrived (PERF);
    // if that one failed, ask again, so the first load fails exactly as before.
    // The last answer of the start-up request, kept in the browser for this customer and language (owner, 2026-10-12: a
    // refresh took 2 to 5 seconds). A visit draws it at once and reads the fresh one behind. Never for a staff view or a
    // payment return (a query string), gone on Log out and after 7 days.
    var BOOT_KEY = 'wsl-boot:' + LOC + ':' + (root.dataset.customer || '');
    var bootCache = {
      read: function () { try { var x = JSON.parse(localStorage.getItem(BOOT_KEY) || 'null'); return x && x.b && x.at > Date.now() - 7 * 864e5 && !location.search ? x : null; } catch (e) { return null; } },
      write: function (b) { if (location.search || !root.dataset.customer) return; try { localStorage.setItem(BOOT_KEY, JSON.stringify({ at: Date.now(), b: b })); } catch (e) { /* full or blocked: the next visit loads as before */ } },
      clear: function () { try { localStorage.removeItem(BOOT_KEY); } catch (e) { /* nothing kept */ } }
    };
    async function load(first) {
      var b = null, early = first && window.__wslBoot, asked = Date.now();
      if (early) {
        window.__wslBoot = null;
        try { b = await api('bootstrap', null, false, early); } catch (e) { b = null; }
      }
      if (!b) b = await api('bootstrap');
      // an invoice email address added or removed while this answer was on its way: keep the list that save answered
      if (S.ieSavedAt > asked && S.b && S.b.customer && b.customer) b.customer.invoiceEmails = S.b.customer.invoiceEmails;
      applyBoot(b);
      if (b.state === 'approved' || b.state === 'paused') bootCache.write(b); else bootCache.clear();
    }
    function applyBoot(b) {
      S.b = b;
      S.loadedAt = Date.now(); S.loadedDay = new Date().toDateString();
      if (b.state !== 'approved' && b.state !== 'paused') return;
      S.items = new Map();
      (b.items || []).forEach(function (i) { S.items.set(i.v, i); });
      if (S.cat) S.cat.items.forEach(function (i) { if (!S.items.has(i.v)) S.items.set(i.v, i); });
      // taps not yet answered by the core keep what the shopper sees (their saves follow)
      var mine = new Map();
      S.timers.forEach(function (tm, v) { mine.set(v, S.basket.get(v) || 0); });
      S.inflight.forEach(function (p, v) { mine.set(v, S.basket.get(v) || 0); });
      S.basket = new Map(); S.saved = new Map();
      b.basket.lines.forEach(function (l) { S.basket.set(l.v, l.q); S.saved.set(l.v, l.q); });
      mine.forEach(function (q, v) { if (q) S.basket.set(v, q); else S.basket.delete(v); });
      S.date = b.basket.date; S.addressId = b.basket.addressId || b.defaultAddressId;
      if (!metaTimer) S.note = b.basket.note || ''; // a note being typed is sent first
      S.onList = new Set(b.list.ids);
      // W1: a kept order key belongs to the basket it was made for; the core empties the
      // basket once that order exists, so another basket here means: never send that key again
      var k = S.key || storedKey();
      if (k && k.sig !== basketSig()) dropKey();
    }
    function loadCatalogue() {
      if (S.cat) return Promise.resolve(S.cat);
      if (!S.catLoading) {
        S.catLoading = api('catalogue').then(function (c) {
          S.cat = c;
          c.items.forEach(function (i) { var had = S.items.get(i.v); S.items.set(i.v, had && had.last ? Object.assign({}, i, { last: had.last }) : i); });
          return c;
        }).catch(function (e) { S.catLoading = null; throw e; });
      }
      return S.catLoading;
    }

    // --------------------------------------------------------- quantities ---
    // A product with a box size is ordered in boxes or in pieces, as the customer picks on its card (owner,
    // 2026-10-08; WS-7 was boxes only). The basket always holds pieces. Boxes until the customer picks pieces,
    // or when the quantity is not whole boxes.
    function inBoxes(it) {
      if (!(it.box > 1)) return false;
      var u = S.unit.get(it.v), q = S.basket.get(it.v) || 0;
      if (u) return u === 'box';
      return !(q % it.box) && !(it.max != null && it.max < it.box); // less than a box left: pieces
    }
    function step(it) { return inBoxes(it) ? it.box : 1; }
    function boxes(it, q) { return inBoxes(it) ? q / it.box : q; }
    function unitWord(it, n, box) { return (box == null ? inBoxes(it) : box) ? t(n === 1 ? 'item.box' : 'item.boxes') : t(n === 1 ? 'item.piece' : 'item.pieces'); }
    // a quantity in words, in boxes when it is whole boxes ("2 boxes", "5 pieces")
    function qtyText(it, q) { var box = it.box > 1 && !(q % it.box); var n = box ? q / it.box : q; return n + ' ' + unitWord(it, n, box); }
    function maxQty(it) { return it.max == null ? 9999 : inBoxes(it) ? Math.floor(it.max / it.box) * it.box : it.max; }
    function soldOut(it) { return !!it.so || (it.max != null && it.max < 1); }
    // The stock on a card (owner, 2026-10-11): only for customers the app marks (customer.showStock), only for a product
    // whose stock is tracked (max), as a green circle with the pieces left. Everyone else sees "Sold out" alone.
    function showStock() { return !!(S.b && S.b.customer && S.b.customer.showStock); }
    function stockHtml(it) { return showStock() && it.max != null ? '<span class="wsl-stock"><i aria-hidden="true"></i>' + esc(t('item.available', { n: it.max })) + '</span>' : ''; }
    // what the switch may hide: never a product in the order, nor the one just scanned
    function hideable(it) { return soldOut(it) && !S.basket.get(it.v) && it.v !== S.flash; }
    function setQty(v, q) {
      var it = S.items.get(v);
      if (!it) return;
      q = Math.max(0, Math.min(q, maxQty(it)));
      if (inBoxes(it) && q % it.box) q = Math.ceil(q / it.box) * it.box;
      if (q > maxQty(it)) q = maxQty(it);
      if (q === 0) S.basket.delete(v); else S.basket.set(v, q);
      paintItem(v); paintFoot();
      clearTimeout(S.timers.get(v));
      S.timers.set(v, setTimeout(function () { save(v); }, 450)); // WS-9: saved as you tap
    }
    // One save at a time per product, in tap order; each sends the quantity at that moment.
    function save(v, keepalive) {
      S.timers.delete(v);
      var prev = S.inflight.get(v) || Promise.resolve();
      var next = prev.then(function () { return sendLine(v, keepalive); });
      S.inflight.set(v, next);
      next.then(function () { if (S.inflight.get(v) === next) S.inflight.delete(v); });
      return next;
    }
    // Resolves to null when the core has the quantity, or to the reason it has not (the tap is undone).
    async function sendLine(v, keepalive) {
      var q = S.basket.get(v) || 0;
      if ((S.saved.get(v) || 0) === q) return null;
      try {
        var r = await api('basket/line', { variantId: v, quantity: q }, keepalive);
        if (r.ok === false) throw new Error(errText(r.error));
        if (q) S.saved.set(v, q); else S.saved.delete(v);
        return null;
      } catch (e) {
        var back = S.saved.get(v) || 0;
        if (back) S.basket.set(v, back); else S.basket.delete(v);
        S.saveFailed = true;
        paintItem(v); paintFoot();
        if (S.screen === 'review') keepFocus(paintMain); // the review shows what will be ordered
        toast(e.message, true);
        return e.message || t('errors.generic');
      }
    }
    // Before an order, a fill or a reload: every tap is on the server, none still on its way.
    // Returns the reasons of the saves that failed meanwhile (empty: all saved).
    async function flush() {
      var pend = [];
      S.timers.forEach(function (tm, v) { clearTimeout(tm); pend.push(v); });
      S.timers.clear();
      pend.forEach(function (v) { save(v); });
      var res = await Promise.all(Array.from(S.inflight.values()));
      return res.filter(Boolean);
    }
    // W3: what the review screen shows is what is ordered; the core checks it against the basket.
    function orderLines() {
      var lines = [];
      S.basket.forEach(function (q, v) { if (S.items.has(v)) lines.push({ v: v, q: q }); });
      return lines.sort(function (a, b) { return a.v < b.v ? -1 : a.v > b.v ? 1 : 0; });
    }
    function basketSig() { return JSON.stringify(orderLines()); }
    // W1: one order key per basket, kept over a reload until the core gives a definite answer.
    var KEY_STORE = 'wsl-order-key';
    function storedKey() { try { return JSON.parse(sessionStorage.getItem(KEY_STORE) || 'null'); } catch (e) { return null; } }
    function keepKey(k) {
      S.key = k;
      try { if (k) sessionStorage.setItem(KEY_STORE, JSON.stringify(k)); else sessionStorage.removeItem(KEY_STORE); } catch (e) { /* storage blocked: kept in memory only */ }
    }
    function dropKey() { keepKey(null); }
    function orderKey(sig) {
      var k = S.key || storedKey();
      if (!k || k.sig !== sig || !k.k) k = { k: (crypto.randomUUID ? crypto.randomUUID() : String(Date.now()) + Math.random().toString(16).slice(2)).replace(/[^0-9A-Za-z_-]/g, ''), sig: sig };
      keepKey(k);
      return k.k;
    }
    function totals() {
      var incl = 0, ex = 0, lines = 0, units = 0, boxesN = 0, mixed = false;
      S.basket.forEach(function (q, v) {
        var it = S.items.get(v);
        if (!it) return;
        // VAT per line, as Shopify and the order emails compute it (PR-9): not the rounded piece price times quantity
        var li = it.c * q;
        // no VAT rate known (no VAT tag, or both): counted at 21%, as the core does (orders.ts totals)
        var rate = it.vat || 21;
        incl += li; ex += li - Math.round(li * rate / (100 + rate)); lines++;
        if (it.box > 1 && !(q % it.box)) boxesN += q / it.box; else { units += q; mixed = true; }
      });
      var r = S.b.rules, d = r.delivery, delivery = d.fixedCents != null ? d.fixedCents : deliveryCost(d.tier, incl);
      // the wholesale page is ex VAT first (owner, 2026-10-07): the minimum counts goods ex VAT, as the core does;
      // a delivery fee is incl. VAT (as Shopify charges it) and shown ex VAT at the rate the core sends
      var missing = r.minimum && ex < r.minimum ? r.minimum - ex : 0;
      var dEx = d.vatPct ? delivery - Math.round(delivery * d.vatPct / (100 + d.vatPct)) : delivery;
      return { incl: incl, ex: ex, vat: incl - ex + (delivery - dEx), lines: lines, boxes: boxesN, units: units, mixed: mixed, delivery: delivery, deliveryEx: dEx, totalEx: ex + dEx, total: incl + delivery, missing: missing };
    }
    // OR-9, as the core computes it: free from an amount, else the highest rule reached, else the flat fee
    // ex VAT of one line, as totals() and Shopify compute it (VAT per line, PR-9)
    function lineEx(it, q) { var li = it.c * q; return it.vat ? li - Math.round(li * it.vat / (100 + it.vat)) : it.x * q; }
    function deliveryCost(d, goods) {
      if (!d) return 0;
      if (d.free_from_cents != null && goods >= d.free_from_cents) return 0;
      var rule = (d.rules || []).filter(function (x) { return goods >= x.from_cents; }).sort(function (a, b) { return b.from_cents - a.from_cents; })[0];
      return rule ? rule.fee_cents : d.flat_cents || 0;
    }
    function countLabel(x) {
      var parts = [];
      if (x.boxes) parts.push(x.boxes + ' ' + t(x.boxes === 1 ? 'item.box' : 'item.boxes'));
      if (x.units) parts.push(x.units + ' ' + t(x.units === 1 ? 'item.piece' : 'item.pieces'));
      return parts.join(' + ');
    }
    function summaryText(x) { return t(x.lines === 1 ? 'bar.summary_one' : 'bar.summary', { products: x.lines, units: countLabel(x) }); }
    function errText(e) {
      if (!e) return t('errors.generic');
      var it = e.variantId && S.items.get(e.variantId);
      var name = e.title || (it && it.t) || '';
      var k = 'errors.' + e.code;
      if (e.code === 'minimum') return t(k, { amount: eur(e.missingCents || 0) });
      return T[k] ? t(k, { name: name, max: e.max == null ? '' : e.max, box: e.box || '' }) : (e.code === 'paused' ? t('state.paused') : e.code === 'stopped' ? t('state.stopped') : e.code === 'credit' ? t('state.credit') : e.code === 'not_open' ? t('state.not_open') : t('errors.generic'));
    }

    // ------------------------------------------------------------------ paint ---
    function render() {
      var b = S.b;
      if (!b) { root.innerHTML = '<div class="wsl-boot wsl-boot--skel" role="status" aria-label="' + esc(t('loading')) + '">' + (CFG.logo ? '<img class="wsl-boot__logo" src="' + esc(CFG.logo) + '" alt="" height="40">' : '') + '<div class="wsl-skel wsl-skel--bar"></div>' + '<div class="wsl-skel wsl-skel--row"></div>'.repeat(5) + '</div>'; return; }
      if (b.state !== 'approved' && b.state !== 'paused') {
        var key = b.state === 'applied' ? 'state.applied' : 'state.retail';
        root.innerHTML = headHtml(false) + '<div class="wsl-notice" role="status">' + esc(t(key)) + '</div>' +
          (b.state !== 'applied' ? '<div class="wsl-pad"><a class="wsl-btn" href="' + esc(root.dataset.logout) + '">' + esc(t('account.logout')) + '</a></div>' : '');
        return;
      }
      root.innerHTML = headHtml(true) + noticeHtml() + installHtml('bar') + '<main class="wsl-main" id="wsl-main"></main><div class="wsl-foot" id="wsl-foot"></div>';
      paintMain();
      paintFoot();
    }
    // "Add to home screen" (owner, 2026-10-11): Android (Chrome, Samsung, Edge) hands the page an install event when the
    // manifest qualifies; the template's head stashes it in window.__wslInstall and one tap on our button opens the
    // phone's own install sheet. iPhone has no such event: Safari gets the two steps (Share, Add to Home Screen). Nothing
    // once installed (standalone), and the bar under the header stays away for 30 days after "Not now"; the My account
    // tab shows the same block without that memory, so a customer can still find it.
    var INSTALL_STORE = 'wsl-install-hidden';
    function installed() { try { return (window.matchMedia && matchMedia('(display-mode: standalone)').matches) || navigator.standalone === true; } catch (e) { return false; } }
    function isIos() { return /iPhone|iPad|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1); }
    function installWay() { if (installed()) return null; if (window.__wslInstall) return 'prompt'; if (isIos()) return 'ios'; return null; }
    function installHidden() { try { return Number(localStorage.getItem(INSTALL_STORE) || 0) > Date.now(); } catch (e) { return false; } }
    function hideInstall(days) { try { localStorage.setItem(INSTALL_STORE, String(Date.now() + days * 864e5)); } catch (e) { /* storage blocked: shown again next visit */ } }
    function installHtml(where) {
      var way = installWay();
      if (!way || (where === 'bar' && installHidden())) return '';
      var body = way === 'prompt' ? '<button type="button" class="wsl-btn wsl-btn--primary" data-act="install">' + esc(t('install.add')) + '</button>'
        : '<p class="wsl-install__how">' + fill(esc(t('install.ios')), { share: ICON.share }) + '</p>';
      return '<div class="wsl-install' + (where === 'bar' ? ' wsl-install--bar' : '') + '" role="group" aria-label="' + esc(t('install.title')) + '">' + ICON.phone +
        '<div class="wsl-install__text"><b>' + esc(t('install.title')) + '</b><span>' + esc(t('install.text')) + '</span>' + body + '</div>' +
        (where === 'bar' ? '<button type="button" class="wsl-icon-btn wsl-install__x" data-act="install-hide" aria-label="' + esc(t('install.not_now')) + '">' + ICON.close + '</button>' : '') + '</div>';
    }
    // the install event often lands after the first paint: put the bar in without redrawing what the customer is doing
    function installChanged() {
      if (!S.b || S.b.state !== 'approved' && S.b.state !== 'paused') return;
      var old = root.querySelector('.wsl-install--bar'), html = installHtml('bar');
      if (old) old.outerHTML = html;
      else { var hd = root.querySelector('.wsl-head'); if (hd && html) hd.insertAdjacentHTML('afterend', html); }
      if (S.screen === 'account') paintMain();
    }
    document.addEventListener('wsl:installable', installChanged);
    window.addEventListener('appinstalled', function () { hideInstall(3650); installChanged(); });
    // The header (owner, 2026-10-11): the logo with the Wholesale tag as on the front page, the cart and the delivery date
    // at the right on every screen, the signed-in company in a chip under them. No cut-off line (the review screen says it).
    function headHtml(full) {
      var c = S.b && S.b.customer;
      // the logo goes to the wholesale page's Product list, never the retail shop (owner, 2026-10-12)
      var brand = '<a class="wsl-head__brand" href="' + esc((root.dataset.root || '/').replace(/\/$/, '') + '/pages/wholesale') + '" data-act="home" aria-label="' + esc(t('brand')) + '">' +
        (CFG.logo ? '<img class="wsl-head__logo" src="' + esc(CFG.logo) + '" alt="' + esc(t('brand')) + '" height="40">' : '<span class="wsl-head__name">' + esc(t('brand')) + '</span>') +
        '<span class="wsl-land__tag wsl-head__tag">' + esc(t('brand_tag')) + '</span></a>';
      // the signed-in company in a chip: in the middle of the top row on a wide screen, centred under it on a phone (the
      // style moves it); a tap opens My account (owner, 2026-10-11)
      var who = c ? '<div class="wsl-head__sub"><button type="button" class="wsl-head__company" data-act="tab" data-val="account">' + ICON.person + '<span>' + esc(c.company || c.firstName) + '</span></button></div>' : '';
      var h = '<header class="wsl-head"><div class="wsl-head__row">' + brand + who;
      if (full) {
        var n = totals().lines;
        h += '<div class="wsl-head__acts">';
        // its name starts with the visible text (label in name, WCAG 2.5.3); the action is added unseen
        if (S.date) h += '<button type="button" class="wsl-date-btn" data-act="review">' + ICON.truck + '<span><small>' + esc(t('header.delivery')) + '</small><b>' + esc(day(S.date)) + '</b></span><span class="wsl-sr">: ' + esc(t('header.change_date')) + '</span></button>';
        h += '<button type="button" class="wsl-cart-btn" data-act="cart" aria-label="' + esc(t('bar.review') + ': ' + t(n === 1 ? 'fill.done_one' : 'fill.done', { n: n })) + '">' + ICON.cart + '<span class="wsl-cart-btn__n" id="wsl-cart-n"' + (n ? '' : ' hidden') + '>' + n + '</span></button></div>';
      }
      h += '</div>';
      if (full && (CFG.highlights || []).length) h += '<div class="wsl-highlights">' + CFG.highlights.map(function (x) { return '<span>' + esc(x) + '</span>'; }).join('') + '</div>';
      return h + '</header>';
    }
    function noticeHtml() {
      if (S.b.state === 'paused') return '<div class="wsl-notice" role="status">' + esc(t('state.paused')) + '</div>';
      if (!S.b.canOrder) return '<div class="wsl-notice" role="status">' + esc(t(S.b.cannotReason === 'stopped' ? 'state.stopped' : S.b.cannotReason === 'credit' ? 'state.credit' : 'state.not_open')) + '</div>';
      return '';
    }

    function paintMain() {
      var main = document.getElementById('wsl-main');
      if (!main) return;
      if (S.screen === 'list') main.innerHTML = listHtml();
      else if (S.screen === 'catalogue') main.innerHTML = catalogueHtml();
      else if (S.screen === 'orders') main.innerHTML = ordersHtml();
      else if (S.screen === 'account') main.innerHTML = accountHtml();
      else if (S.screen === 'review') main.innerHTML = reviewHtml();
      else if (S.screen === 'done') main.innerHTML = doneHtml();
      if (S.screen === 'list' || S.screen === 'catalogue') paintRows();
      if (S.flash) {
        var el = main.querySelector('[data-row="' + CSS.escape(S.flash) + '"]');
        if (el) { el.classList.add('wsl-row--flash'); el.scrollIntoView({ block: 'center' }); }
        S.flash = null;
      }
    }
    // first: a chip before the others (the aisle chip: in sight on a phone, so a chosen aisle is never missed)
    function chips(list, cur, act, first) {
      return '<div class="wsl-chips" role="group">' + (first || '') + list.map(function (c) {
        return '<button type="button" class="wsl-chip" data-act="' + act + '" data-val="' + esc(c[0]) + '" aria-pressed="' + (c[0] === cur) + '">' + esc(c[1]) + '</button>';
      }).join('') + '</div>';
    }
    // The aisles (product types) of the products on the order list and in the order, for the aisle chip
    function listAisles() {
      var seen = new Set();
      S.b.list.ids.forEach(function (v) { var it = S.items.get(v); if (it && it.aisle) seen.add(it.aisle); });
      S.basket.forEach(function (q, v) { var it = S.items.get(v); if (it && it.aisle) seen.add(it.aisle); });
      return Array.from(seen).sort(function (a, b) { return a.localeCompare(b, TAG); });
    }
    // a chip that opens the phone's own list; the select lies over it unseen, at 16px so iPhones do not zoom in
    function aisleChip(aisles) {
      return '<label class="wsl-chip wsl-chip--pick" data-on="' + !!S.listAisle + '"><span>' + esc(S.listAisle || t('list.aisle_all')) + '</span>' + ICON.down +
        '<select id="wsl-aisle" aria-label="' + esc(t('catalogue.aisles')) + '"><option value="">' + esc(t('list.aisle_all')) + '</option>' +
        aisles.map(function (a) { return '<option value="' + esc(a) + '"' + (a === S.listAisle ? ' selected' : '') + '>' + esc(a) + '</option>'; }).join('') + '</select></label>';
    }
    function onListShown(it) { return (S.temp === 'all' || it.temp === S.temp) && (!S.listAisle || it.aisle === S.listAisle) && match(it, S.q); }
    function searchHtml(id, value, placeholder) {
      return '<div class="wsl-search"><label>' + ICON.search + '<span class="wsl-sr">' + esc(placeholder) + '</span><input type="search" id="' + id + '" value="' + esc(value) + '" placeholder="' + esc(placeholder) + '" autocomplete="off" enterkeyhint="search"></label>' +
        '<button type="button" class="wsl-icon-btn" data-act="scan" aria-label="' + esc(t('scan.button')) + '">' + ICON.scan + '</button></div>';
    }
    function listHtml() {
      var b = S.b, h = '<div class="wsl-tools">';
      if (CFG.banner || CFG.bannerText) h += '<div class="wsl-banner">' + (CFG.banner ? '<img src="' + esc(CFG.banner) + '" alt="" loading="lazy">' : '') + (CFG.bannerText ? '<p>' + esc(CFG.bannerText) + '</p>' : '') + '</div>';
      h += searchHtml('wsl-q', S.q, t('list.search'));
      if (b.lastOrder) h += '<button type="button" class="wsl-repeat" data-act="again" data-order="' + esc(b.lastOrder.id) + '"><span style="flex-direction:row;align-items:center;gap:10px">' + ICON.repeat +
        '<span><b style="color:inherit">' + esc(t('list.repeat')) + '</b><small>' + esc(t(b.lastOrder.count === 1 ? 'list.repeat_meta_one' : 'list.repeat_meta', { date: day(b.lastOrder.date), count: b.lastOrder.count })) + '</small></span></span><b>' + esc(t('list.fill')) + '</b></button>';
      var aisles = listAisles();
      if (S.listAisle && aisles.indexOf(S.listAisle) < 0) S.listAisle = null;
      h += chips([['all', t('temp.all')], ['chilled', t('temp.chilled')], ['frozen', t('temp.frozen')], ['ambient', t('temp.ambient')]], S.temp, 'temp', aisles.length > 1 ? aisleChip(aisles) : '');
      return h + '</div><div class="wsl-rows" id="wsl-rows"></div>';
    }
    function catalogueHtml() {
      var h = '<div class="wsl-tools">' + searchHtml('wsl-cq', S.catQ, t('catalogue.search', { n: S.cat ? S.cat.items.length : '' }));
      if (S.cat) {
        var list = [['', t('catalogue.all')]];
        (CFG.featured || []).forEach(function (f, i) { list.push(['f' + i, f.title]); });
        S.cat.aisles.forEach(function (a) { list.push([a, a]); });
        h += chips(list, S.aisle || '', 'aisle');
      }
      return h + '</div><div class="wsl-rows" id="wsl-rows"></div>';
    }
    function match(it, q) {
      if (!q) return true;
      var s = q.toLowerCase();
      return it.t.toLowerCase().indexOf(s) >= 0 || (it.s || '').toLowerCase() === s || (it.s || '').toLowerCase().indexOf(s) === 0 || (it.b || '') === q.trim() || (it.vendor || '').toLowerCase().indexOf(s) >= 0;
    }
    function paintRows() {
      var box = document.getElementById('wsl-rows');
      if (!box) return;
      var html = '';
      if (S.screen === 'list') {
        var b = S.b;
        if (!b.list.reviewed) html += '<p class="wsl-empty">' + esc(t('list.pending')) + '</p>';
        var ids = b.list.ids.filter(function (v) { return S.items.has(v); });
        var rows = ids.map(function (v) { return S.items.get(v); }).filter(onListShown).sort(byName);
        var outN = rows.filter(hideable).length;
        if (S.hideOut) rows = rows.filter(function (it) { return !hideable(it); });
        if (outN) html += '<div class="wsl-rows__head">' + soldOutSwitch(outN) + '</div>';
        if (b.list.reviewed && !ids.length) html += '<p class="wsl-empty">' + esc(t('list.empty')) + '</p>';
        else if (ids.length && !rows.length) html += '<p class="wsl-empty">' + esc(t('list.no_match')) + '</p>';
        html += rows.map(function (it) { return rowHtml(it, 'list'); }).join('');
        // products in the order that are not on the list (ordered again, from the catalogue)
        var extra = [];
        S.basket.forEach(function (q, v) { if (!S.onList.has(v) && S.items.has(v)) extra.push(S.items.get(v)); });
        extra = extra.filter(onListShown).sort(byName);
        if (extra.length) html += '<p class="wsl-section-title">' + esc(t('list.in_order')) + '</p>' + extra.map(function (it) { return rowHtml(it, 'list'); }).join('');
        html += '<button type="button" class="wsl-btn wsl-btn--ghost" data-act="tab" data-val="catalogue" style="min-height:48px">+ ' + esc(t('list.add_products')) + '</button>';
      } else {
        if (!S.cat) {
          html = '<p class="wsl-empty" role="status">' + esc(t('loading')) + '</p>';
          loadCatalogue().then(function () { if (S.screen === 'catalogue') paintMain(); }).catch(function (e) { box.innerHTML = '<p class="wsl-empty">' + esc(e.message) + '</p>'; });
        } else {
          var feat = S.aisle && S.aisle.charAt(0) === 'f' && /^f\d$/.test(S.aisle) ? new Set((CFG.featured[Number(S.aisle.slice(1))] || { ids: [] }).ids) : null;
          var all = S.cat.items.filter(function (it) { return (feat ? feat.has(it.v) : !S.aisle || it.aisle === S.aisle) && match(it, S.catQ); }).sort(byAisleName);
          // stock as last loaded: the order list's copy when there is one (the catalogue's copy keeps the aisle)
          var outN = all.filter(function (it) { return hideable(S.items.get(it.v) || it); }).length;
          if (S.hideOut) all = all.filter(function (it) { return !hideable(S.items.get(it.v) || it); });
          if (!all.length) html = '<p class="wsl-empty">' + esc(t('list.no_match')) + '</p>';
          html += '<div class="wsl-rows__head"><p class="wsl-section-title">' + esc(countText(all.length)) + '</p>' + (outN ? soldOutSwitch(outN) : '') + '</div>';
          html += all.slice(0, S.catShown).map(function (it) { return rowHtml(S.items.get(it.v) || it, 'cat'); }).join('');
          if (all.length > S.catShown) html += '<button type="button" class="wsl-btn" data-act="more">' + esc(t('catalogue.more')) + '</button>';
        }
      }
      box.innerHTML = html;
      announce(box.querySelectorAll('.wsl-row').length);
    }
    // Products in alphabetical order (owner, 2026-10-11), the catalogue by aisle first
    function byName(a, b) { return a.t.localeCompare(b.t, TAG); }
    function byAisleName(a, b) { return (a.aisle || '').localeCompare(b.aisle || '', TAG) || byName(a, b); }
    function countText(n) { return t(n === 1 ? 'catalogue.count_one' : 'catalogue.count', { n: n }); }
    // n: the sold out products in what the search and filters show, hidden or not
    function soldOutSwitch(n) {
      return '<button type="button" class="wsl-switch" data-act="soldout" aria-pressed="' + S.hideOut + '">' + esc(t('list.hide_sold_out', { n: n })) + '</button>';
    }
    // W13: one live region outside everything the page repaints, so screen readers hear it.
    var live = document.createElement('p');
    live.className = 'wsl-sr'; live.id = 'wsl-live'; live.setAttribute('aria-live', 'polite');
    root.parentNode.insertBefore(live, root.nextSibling);
    var announceTimer = null;
    function say(text, delay) {
      clearTimeout(announceTimer);
      live.textContent = ''; // the same words twice are read twice
      announceTimer = setTimeout(function () { live.textContent = text; }, delay || 100);
    }
    function announce(n) { say(countText(n), 600); }
    // The card: the price per piece and per box ex VAT, nothing else (owner, 2026-10-09; incl. VAT and the retail price
    // are in the details). A product without a VAT tag has no ex VAT price: its price is shown as what it is, incl. VAT.
    function priceHtml(it) {
      var h = '<span class="wsl-row__price">' + esc(eur(it.vat ? it.x : it.c)) + ' <small>' + esc(t(it.vat ? 'item.per_piece_ex' : 'item.per_piece_incl')) + '</small></span>';
      // the box as the basket and the invoice count it (VAT per line)
      if (it.box > 1) h += '<span class="wsl-row__box">' + esc(eur(it.vat ? lineEx(it, it.box) : it.c * it.box) + ' ' + t('item.per_box_of', { n: it.box })) + '</span>';
      return h;
    }
    // a product image at another width (Shopify's image CDN takes width=)
    function imgAt(src, w) { return /[?&]width=\d+/.test(src) ? src.replace(/([?&]width=)\d+/, '$1' + w) : src + (src.indexOf('?') < 0 ? '?' : '&') + 'width=' + w; }
    function stepperHtml(it, q) {
      var n = boxes(it, q), atMax = q + step(it) > maxQty(it);
      return '<div class="wsl-step"><button type="button" data-act="dec" data-v="' + esc(it.v) + '" aria-label="' + esc(t('item.less', { name: it.t })) + '"' + (q ? '' : ' disabled') + '>−</button>' +
        // the number can be typed too (a B2B order is often 10 or 20 at once); its unit is the word under it
        '<span class="wsl-step__qty"><input class="wsl-step__input" type="text" inputmode="numeric" pattern="[0-9]*" maxlength="4" size="4" autocomplete="off" enterkeyhint="done" data-act="qty" data-v="' + esc(it.v) + '" value="' + n + '" aria-label="' + esc(t('item.qty', { name: it.t }) + ', ' + unitWord(it, n)) + '"><small aria-hidden="true">' + esc(unitWord(it, n)) + '</small></span>' +
        '<button type="button" class="wsl-step__plus" data-act="inc" data-v="' + esc(it.v) + '" aria-label="' + esc(t('item.more', { name: it.t })) + '"' + (atMax ? ' disabled' : '') + '>+</button></div>';
    }
    // Boxes or pieces, on the card of a product with a box size
    function unitHtml(it) {
      if (!(it.box > 1)) return '';
      var box = inBoxes(it), b = function (u, on, label, off) { return '<button type="button" data-act="unit" data-val="' + u + '" data-v="' + esc(it.v) + '" aria-pressed="' + on + '"' + (off ? ' disabled' : '') + '>' + esc(label) + '</button>'; };
      // less than a box left: pieces only
      return '<div class="wsl-unit" role="group" aria-label="' + esc(t('item.unit', { name: it.t })) + '">' + b('box', box, t('item.unit_boxes'), it.max != null && it.max < it.box) + b('piece', !box, t('item.unit_pieces')) + '</div>';
    }
    function rowHtml(it, mode) {
      var q = S.basket.get(it.v) || 0;
      var thumb = it.img ? '<img class="wsl-thumb" src="' + esc(imgAt(it.img, 240)) + '" alt="" loading="lazy" width="80" height="80">' : '<span class="wsl-thumb" aria-hidden="true">' + esc((it.s || '').slice(0, 5)) + '</span>';
      var out = soldOut(it);
      // the stepper and Boxes / Pieces, on the list and in the catalogue alike (owner, 2026-10-11); sold out: a line under the price instead
      void mode;
      var act = out ? '' : stepperHtml(it, q) + unitHtml(it);
      // the name is the button to the details; a tap anywhere else on the card outside the controls opens them too
      return '<div class="wsl-row' + (q ? ' wsl-row--in' : '') + (out ? ' wsl-row--out' : '') + '" data-row="' + esc(it.v) + '">' + thumb +
        '<div class="wsl-row__text"><button type="button" class="wsl-row__name" data-act="info" data-v="' + esc(it.v) + '" aria-haspopup="dialog"><span>' + esc(it.t) + '</span></button>' + priceHtml(it) +
        (out ? '<span class="wsl-soldout">' + esc(t('item.sold_out')) + '</span>' : stockHtml(it)) + '</div>' +
        (act ? '<div class="wsl-row__act">' + act + '</div>' : '') + '</div>';
    }
    function paintItem(v) {
      var el = root.querySelector('[data-row="' + CSS.escape(v) + '"]');
      var it = S.items.get(v);
      if (!el || !it) return;
      var mode = S.screen === 'catalogue' ? 'cat' : 'list';
      var tmp = document.createElement('div');
      tmp.innerHTML = rowHtml(it, mode);
      var focused = document.activeElement && el.contains(document.activeElement) ? document.activeElement.getAttribute('data-act') : null;
      el.replaceWith(tmp.firstChild);
      if (focused) {
        // the same control, else + or − (+ is disabled at the stock limit)
        var row = root.querySelector('[data-row="' + CSS.escape(v) + '"]');
        var again = [focused, 'inc', 'dec'].map(function (a) { return row && row.querySelector('[data-act="' + a + '"]'); }).filter(function (b) { return b && !b.disabled; })[0];
        if (again) again.focus();
      }
    }
    // W13: after a repaint, focus goes back to the control that had it (or was pressed).
    function focusKey(el) {
      el = el || document.activeElement;
      if (!el || !root.contains(el) || el === root) return null;
      var k = { id: el.id, act: el.getAttribute('data-act'), v: el.getAttribute('data-v'), val: el.getAttribute('data-val'), s: null, e: null };
      try { k.s = el.selectionStart; k.e = el.selectionEnd; } catch (e) { /* no text selection here */ }
      return k;
    }
    function refocus(k) {
      if (!k || (!k.id && !k.act)) return false;
      var el = k.id ? document.getElementById(k.id) : root.querySelector('[data-act="' + k.act + '"]' + (k.v != null ? '[data-v="' + CSS.escape(k.v) + '"]' : '') + (k.val != null ? '[data-val="' + CSS.escape(k.val) + '"]' : ''));
      if (!el || el.disabled) return false;
      el.focus({ preventScroll: true });
      try { if (k.s != null) el.setSelectionRange(k.s, k.e); } catch (e) { /* not a text field */ }
      return true;
    }
    function keepFocus(paint, el) { var k = focusKey(el); paint(); refocus(k); }
    function paintFoot() {
      var foot = document.getElementById('wsl-foot');
      if (!foot) return;
      var h = '';
      var x = totals();
      // the cart's count in the header follows the order (owner, 2026-10-11: the cart is always at the top right)
      var cn = document.getElementById('wsl-cart-n');
      if (cn) { cn.textContent = x.lines; cn.hidden = !x.lines; var cb = cn.parentNode; if (cb) cb.setAttribute('aria-label', t('bar.review') + ': ' + t(x.lines === 1 ? 'fill.done_one' : 'fill.done', { n: x.lines })); }
      // the order bar on every tab, also Orders and My account (owner, 2026-10-11: "I am lost, how do I open the cart?")
      if (S.screen !== 'review' && S.screen !== 'done' && x.lines) {
        h += '<div class="wsl-bar">';
        if (x.missing) {
          var pct = Math.min(100, Math.round((x.ex / S.b.rules.minimum) * 100));
          h += '<div class="wsl-progress"><div class="wsl-progress__track"><div class="wsl-progress__fill" style="width:' + pct + '%"></div></div><span>' + esc(t('bar.minimum', { amount: eur(x.missing), min: eur(S.b.rules.minimum) })) + '</span></div>';
        }
        h += '<div class="wsl-bar__row"><span class="wsl-bar__sum"><small>' + esc(summaryText(x)) + '</small><b>' + esc(eur(x.ex)) + ' <small>' + esc(t('bar.ex')) + '</small></b></span>' +
          '<button type="button" class="wsl-btn wsl-btn--primary" data-act="review">' + esc(t('bar.review')) + '</button></div></div>';
      }
      if (S.screen === 'review') {
        var can = x.lines && !x.missing && S.b.canOrder && S.b.state === 'approved' && !S.placing && S.date && !(S.b.gone || []).length;
        var label = S.placing ? t('review.placing') : x.missing ? t('review.add_more', { amount: eur(x.missing) }) : t('review.place', { total: eur(x.totalEx) + ' ' + t('bar.ex') });
        h += '<div class="wsl-place"><button type="button" class="wsl-btn wsl-btn--primary wsl-btn--wide" data-act="place"' + (can ? '' : ' disabled') + '>' + esc(label) + '</button></div>';
      }
      if (S.screen !== 'review' && S.screen !== 'done') {
        h += '<nav class="wsl-tabs" aria-label="' + esc(t('tabs.label')) + '">' + [['list', 'tabs.order_list'], ['catalogue', 'tabs.catalogue'], ['orders', 'tabs.orders'], ['account', 'tabs.account']].map(function (x2) {
          return '<button type="button" class="wsl-tab" data-act="tab" data-val="' + x2[0] + '"' + (S.screen === x2[0] ? ' aria-current="page"' : '') + '>' +
            '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="' + ICON.tab[x2[0]] + '"/></svg>' + esc(t(x2[1])) + '</button>';
        }).join('') + '</nav>';
      }
      foot.innerHTML = h;
      var main = document.getElementById('wsl-main');
      if (main) main.style.paddingBottom = (foot.offsetHeight + 12) + 'px';
    }

    // ----------------------------------------------------------------- review ---
    function reviewHtml() {
      var b = S.b, x = totals();
      var dates = b.dates.list, first = dates.slice(0, 5);
      if (S.date && first.indexOf(S.date) < 0 && dates.indexOf(S.date) >= 0) first[4] = S.date;
      var h = '<div class="wsl-pad"><div class="wsl-titlebar"><button type="button" class="wsl-icon-btn" style="border:0" data-act="back" aria-label="' + esc(t('review.back')) + '">' + ICON.back + '</button><h1>' + esc(t('review.title')) + '</h1></div>';
      if (S.errors && S.errors.length) h += '<div class="wsl-errors" role="alert">' + S.errors.map(function (e) { return '<span>' + esc(e) + '</span>'; }).join('') + '</div>';
      h += '<section class="wsl-card" aria-labelledby="wsl-h-date"><h2 id="wsl-h-date">' + esc(t('review.date')) + '</h2>';
      if (!dates.length) h += '<p>' + esc(t('header.no_dates')) + '</p>';
      else {
        h += '<div class="wsl-dates" role="group" aria-labelledby="wsl-h-date">' + first.map(function (d) {
          var dt = new Date(d + 'T12:00:00Z');
          return '<button type="button" class="wsl-date" data-act="date" data-val="' + d + '" aria-pressed="' + (d === S.date) + '" aria-label="' + esc(day(d, true)) + '"><small>' + esc(dt.toLocaleDateString(TAG, { weekday: 'short', timeZone: 'UTC' })) + '</small><b>' + dt.getUTCDate() + '</b><small>' + esc(dt.toLocaleDateString(TAG, { month: 'short', timeZone: 'UTC' })) + '</small></button>';
        }).join('') + '</div>';
        if (dates.length > 5) h += '<label class="wsl-field"><span>' + esc(t('review.more_dates')) + '</span><select class="wsl-select" id="wsl-more-dates">' + dates.map(function (d) { return '<option value="' + d + '"' + (d === S.date ? ' selected' : '') + '>' + esc(day(d, true)) + '</option>'; }).join('') + '</select></label>';
        // the cut-off (Settings > Delivery dates): said where the date is picked, not only in the header
        if (b.dates.cutoff) h += '<p class="wsl-cutnote">' + ICON.clock + '<span>' + esc(t('review.cutoff_rule', { time: b.dates.cutoff })) + '</span></p>';
      }
      h += '</section>';
      // CU-9 (owner, 2026-10-09): one of the Dutch addresses (OR-8), each can be changed, and a new one added
      var addrs = (b.addresses || []).filter(function (a) { return a.nl; });
      if (addrs.length && addrs.every(function (a) { return a.id !== S.addressId; })) S.addressId = (addrs.filter(function (a) { return a.def; })[0] || addrs[0]).id;
      h += '<section class="wsl-card" aria-labelledby="wsl-h-addr"><h2 id="wsl-h-addr">' + esc(t('review.address')) + '</h2>';
      if (!addrs.length) h += '<div class="wsl-errors" role="alert"><span>' + esc(t('errors.address')) + '</span></div>';
      else h += '<div class="wsl-addrs" role="radiogroup" aria-labelledby="wsl-h-addr">' + addrs.map(function (a) {
        return '<div class="wsl-addr"><label><input type="radio" name="wsl-addr" value="' + esc(a.id) + '"' + (a.id === S.addressId ? ' checked' : '') + '><span>' + esc(a.label) + '</span></label>' +
          '<button type="button" class="wsl-link" data-act="addr-edit" data-val="' + esc(a.id) + '" aria-label="' + esc(t('address.change_one', { address: a.label })) + '">' + esc(t('address.change')) + '</button></div>';
      }).join('') + '</div>';
      h += '<button type="button" class="wsl-btn wsl-btn--ghost" data-act="addr-add">+ ' + esc(t('address.add')) + '</button></section>';
      // the line amounts are ex VAT: said once, above them, not on every line
      h += '<section class="wsl-card"><h2 class="wsl-card__head">' + esc(x.lines ? summaryText(x) : t('review.products')) + (x.lines ? '<small>' + esc(t('bar.ex')) + '</small>' : '') + '</h2>';
      if (!x.lines) h += '<p>' + esc(t('review.empty')) + '</p>';
      S.basket.forEach(function (q, v) {
        var it = S.items.get(v);
        if (!it) return;
        var whole = it.box > 1 && !(q % it.box);
        h += '<div class="wsl-line"><span class="wsl-line__name">' + esc(it.t) + '<small>' + esc(qtyText(it, q) + (whole ? ' × ' + it.box : '') + (it.vat ? '' : ' · ' + t('item.incl'))) + '</small></span><b>' + esc(eur(lineEx(it, q))) + '</b>' +
          '<button type="button" class="wsl-icon-btn" style="border:0" data-act="remove" data-v="' + esc(v) + '" aria-label="' + esc(t('review.remove', { name: it.t })) + '">' + ICON.close + '</button></div>';
      });
      (b.gone || []).forEach(function (g) {
        h += '<div class="wsl-line"><span class="wsl-line__name">' + esc(g.t || t('errors.not_found')) + '<small style="color:var(--wsl-bad)">' + esc(t('review.gone')) + '</small></span>' +
          '<button type="button" class="wsl-icon-btn" style="border:0" data-act="drop" data-v="' + esc(g.v) + '" aria-label="' + esc(t('review.remove', { name: g.t })) + '">' + ICON.close + '</button></div>';
      });
      h += '</section>';
      h += '<section class="wsl-card"><label class="wsl-field" for="wsl-note"><span>' + esc(t('review.note')) + ' <span style="font-weight:400;color:var(--wsl-muted)">' + esc(t('review.optional')) + '</span></span>' +
        '<textarea id="wsl-note" class="wsl-textarea" rows="2" maxlength="500" placeholder="' + esc(t('review.note_placeholder')) + '">' + esc(S.note) + '</textarea></label></section>';
      h += '<section class="wsl-card"><div class="wsl-sum"><div><span>' + esc(t('review.subtotal')) + '</span><span>' + esc(eur(x.ex)) + '</span></div>' +
        '<div><span>' + esc((b.rules.delivery.title || t('review.delivery')) + (x.delivery ? ' ' + t('bar.ex') : '')) + '</span><span>' + esc(x.delivery ? eur(x.deliveryEx) : t('review.free')) + '</span></div>' +
        '<div class="wsl-sum__total"><span>' + esc(t('review.total_ex')) + '</span><span>' + esc(eur(x.totalEx)) + '</span></div>' +
        '<div style="color:var(--wsl-muted)"><span>' + esc(t('review.vat')) + '</span><span>' + esc(eur(x.vat)) + '</span></div>' +
        '<div style="color:var(--wsl-muted)"><span>' + esc(t('review.total')) + '</span><span>' + esc(eur(x.total)) + '</span></div></div>' +
        '<div class="wsl-pay">' + ICON.invoice + '<span>' + esc(b.customer.paymentType === 'account' ? t('review.account', { days: b.customer.paymentDays }) : t('review.online')) + '</span></div></section>';
      return h + '</div>';
    }
    async function place() {
      if (S.placing) return;
      S.placing = true; S.errors = null; paintFoot();
      var reload = false, changed = false;
      try {
        // W2: a change that did not save means the review showed something else than the core holds
        var failed = await flush();
        if (failed.length || S.saveFailed) {
          S.saveFailed = false;
          S.errors = failed.concat(t('errors.not_saved')).filter(function (m, i, a) { return a.indexOf(m) === i; });
          return;
        }
        await saveMeta();
        var lines = orderLines(), sums = totals(); // sums: for the done screen's total ex VAT
        // c: the price per piece this page shows, so the core never charges a price the customer has not seen
        var shown = lines.map(function (l) { var it = S.items.get(l.v); return { v: l.v, q: l.q, c: it ? it.c : null }; });
        // the address on screen goes with the order: a deleted one is refused (address_gone), never swapped for the default
        var r = await call(base, 'order', LOC, { key: orderKey(JSON.stringify(lines)), date: S.date, addressId: S.addressId || null, lines: shown }, false, 60000);
        var b = r.body || {};
        if (r.status === 429) throw failure('errors.too_many');
        if (b.ok) {
          dropKey();
          // ex VAT first, as everywhere on this page (owner, 2026-10-09); only when Shopify's total is the one the page showed
          S.done = { status: b.status, name: b.orderName || b.draftName, date: b.deliveryDate, url: b.checkoutUrl, total: b.totalCents, totalEx: b.totalCents === sums.total ? sums.totalEx : null };
          S.basket = new Map(); S.saved = new Map();
          S.note = ''; S.metaSaved = null; // the core empties the basket's date and note too
          go('done');
          if (b.status === 'checkout' && b.checkoutUrl) setTimeout(function () { location.href = b.checkoutUrl; }, 900);
          return;
        }
        var errs = Array.isArray(b.errors) && b.errors.length ? b.errors : null;
        var pending = !!errs && errs.some(function (e) { return e.code === 'pending'; });
        if (errs && !pending) dropKey(); // a definite no: nothing was made with this key
        S.errors = (errs || [{ code: 'generic' }]).map(errText);
        // read the basket, dates, stock and prices again, unless the order is still being made
        reload = !!errs && !pending;
        changed = !!errs && errs.some(function (e) { return e.code === 'basket_changed'; });
      } catch (e) {
        // no answer: the key stays, so trying again cannot make a second order
        S.errors = [e.network ? t('errors.network') : e.message || t('errors.generic')];
        reload = e.key === 'errors.date';
      } finally {
        if (reload) { try { await load(); } catch (e) { /* keep what we have */ } }
        S.placing = false;
        if (changed) S.screen = 'review';
        if (reload) render();
        else if (S.screen === 'review') { paintMain(); paintFoot(); }
        // the message is at the top of the review, a long order is scrolled to the button: "nothing happens" (2026-10-21)
        var er = S.screen === 'review' && root.querySelector('.wsl-errors');
        if (er) er.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }
    }
    var metaTimer = null;
    async function saveMeta(keepalive) {
      clearTimeout(metaTimer); metaTimer = null;
      var want = { date: S.date, note: S.note, addressId: S.addressId };
      if (S.metaSaved && S.metaSaved.date === want.date && S.metaSaved.note === want.note && S.metaSaved.addressId === want.addressId) return;
      await api('basket/meta', want, keepalive);
      S.metaSaved = want;
    }
    function metaFailed(e) {
      toast(e.message, true);
      if (e.key === 'errors.date') refreshSoon(); // the dates on the page are out of date
    }

    // ------------------------------------------------------- orders, account ---
    function ordersHtml() {
      if (!S.orders) {
        api('orders').then(function (o) { S.orders = o; if (S.screen === 'orders') paintMain(); }).catch(function (e) {
          var main = document.getElementById('wsl-main');
          if (S.screen === 'orders' && main) main.innerHTML = '<div class="wsl-boot" role="alert"><p>' + esc(e.message) + '</p><p style="margin-top:12px"><button type="button" class="wsl-btn" data-act="tab" data-val="orders">' + esc(t('retry')) + '</button></p></div>';
        });
        return '<p class="wsl-empty" role="status">' + esc(t('loading')) + '</p>';
      }
      var o = S.orders;
      var h = '<div class="wsl-pad"><div class="wsl-card" style="flex-direction:row;justify-content:space-between;align-items:center"><span style="display:flex;flex-direction:column;gap:2px"><span style="font-size:13px;color:var(--wsl-muted)">' + esc(t('orders.open')) + '</span><b style="font-size:20px">' + esc(eur(o.open.cents)) + ' <small style="font-size:12px;font-weight:500;color:var(--wsl-muted)">' + esc(t('item.incl')) + '</small></b></span>' +
        '<span style="font-size:13px;font-weight:600;color:var(--wsl-muted);text-align:right">' + esc(o.open.count ? t('orders.open_meta', { count: o.open.count, date: o.open.nextDue ? day(o.open.nextDue) : '' }) : t('orders.none_open')) + '</span></div>';
      // back from Stripe (?pay=done, cancelled, expired, nothing, unavailable, error), said once
      if (S.payNote) h += '<div class="wsl-notice" role="status">' + esc(t('pay.' + (S.payNote === 'error' ? 'unavailable' : S.payNote))) + '</div>';
      // Pay all: every invoiced open order in one Stripe payment, as the reminder's button (RC-8)
      if (o.payAll) h += '<div class="wsl-card wsl-payall"><a class="wsl-btn wsl-btn--primary" href="' + esc(o.payAll.url) + '">' + esc(t('orders.pay_all', { amount: eur(o.payAll.cents) })) + '</a>' +
        '<small class="wsl-row__sub">' + esc(t('orders.pay_all_note', { count: o.payAll.count })) + '</small></div>';
      if (!o.orders.length) h += '<p class="wsl-empty">' + esc(t('orders.empty')) + '</p>';
      o.orders.forEach(function (x) {
        var badge = x.state === 'cancelled' ? ['wsl-badge--off', t('orders.cancelled')] : x.state === 'paid' ? ['', t('orders.paid')] : x.state === 'overdue' ? ['wsl-badge--bad', t('orders.overdue', { date: day(x.due) })]
          : x.state === 'received' ? ['', t('orders.received')] : x.state === 'to_pay' ? ['wsl-badge--due', t('orders.to_pay')] : ['wsl-badge--due', x.due ? t('orders.open_state', { date: day(x.due) }) : t('orders.open_badge')];
        var meta = x.items == null ? t('orders.placed', { date: day(x.at) }) : t(x.items === 1 ? 'orders.meta_one' : 'orders.meta', { date: day(x.at), n: x.items });
        var action = x.state === 'to_pay' && x.payUrl ? '<a class="wsl-btn wsl-btn--primary" href="' + esc(x.payUrl) + '">' + esc(t('done.pay_button')) + '</a>'
          : x.state !== 'cancelled' && x.state !== 'received' && x.state !== 'to_pay' ? '<span class="wsl-order__acts">' + (x.payUrl ? '<a class="wsl-btn wsl-btn--primary" href="' + esc(x.payUrl) + '">' + esc(t('orders.pay')) + '</a>' : '') +
            (x.draft ? '' : '<button type="button" class="wsl-btn wsl-btn--line" data-act="again" data-order="' + esc(x.id) + '">' + esc(t('orders.again')) + '</button>') + '</span>' : '';
        h += '<div class="wsl-card wsl-order"><div class="wsl-order__top"><span><b style="font-size:15px">' + esc(x.name) + '</b><small>' + esc(meta) + (x.delivery ? ' · ' + esc(t('orders.delivery', { date: day(x.delivery) })) : '') + '</small></span><span class="wsl-badge ' + badge[0] + '">' + esc(badge[1]) + '</span></div>' +
          '<div class="wsl-order__bottom"><span style="display:flex;flex-direction:column"><b>' + esc(eur(x.ex != null ? x.ex : x.total)) + ' <small style="font-weight:500;color:var(--wsl-muted)">' + esc(t(x.ex != null ? 'bar.ex' : 'item.incl')) + '</small></b>' +
          (x.ex != null ? '<small class="wsl-row__sub">' + esc(eur(x.total) + ' ' + t('item.incl')) + '</small>' : '') + '</span>' + action + '</div>' +
          // what was ordered: a window with the products, a tick box each, to add a part of the order again (owner, 2026-10-11)
          (x.lines && x.lines.length ? '<div class="wsl-order__lines"><button type="button" class="wsl-linkbtn" data-act="lines" data-order="' + esc(x.id) + '">' + esc(t('orders.lines', { n: x.lines.length })) + '</button></div>' : '') +
          // the order's invoice and credit notes (our own invoices, through the signed proxy)
          (x.invoices && x.invoices.length ? '<div style="padding-top:8px;font-size:13px;display:flex;flex-wrap:wrap;gap:4px 14px">' + x.invoices.map(function (d) {
            return '<a href="' + esc(d.url) + '" target="_blank" rel="noopener" style="color:inherit;text-decoration:underline">' + esc(t(d.kind === 'credit_note' ? 'orders.credit_note' : 'orders.invoice', { number: d.number })) + '</a>';
          }).join('') + '</div>' : '') + '</div>';
      });
      return h + '</div>';
    }
    function accountHtml() {
      var b = S.b, c = b.customer, contact = CFG.contact || {};
      var h = '<div class="wsl-pad"><section class="wsl-card"><h2>' + esc(t('tabs.account')) + '</h2><dl class="wsl-kv">' +
        '<dt>' + esc(t('account.company')) + '</dt><dd>' + esc(c.company) + '</dd>' +
        '<dt>' + esc(t('account.email')) + '</dt><dd>' + esc(c.email) + '</dd>' +
        '<dt>' + esc(t('account.payment')) + '</dt><dd>' + esc(c.paymentType === 'account' ? t('account.on_account', { days: c.paymentDays }) : t('account.online')) + '</dd></dl></section>';
      // their delivery days, the cut-off and the minimum order (owner, 2026-10-12)
      var wd = (b.dates && b.dates.weekdays || []).map(function (n) { return new Date(Date.UTC(2024, 0, Number(n))).toLocaleDateString(TAG, { weekday: 'long', timeZone: 'UTC' }); });
      h += '<section class="wsl-card"><h2>' + esc(t('account.delivery')) + '</h2>' + (wd.length ? '<p>' + esc(t('account.delivery_days', { days: wd.join(', ') })) + '</p>' : '') +
        (b.dates && b.dates.cutoff ? '<p>' + esc(t('review.cutoff_rule', { time: b.dates.cutoff })) + '</p>' : '') +
        '<p>' + esc(b.rules && b.rules.minimum ? t('account.minimum', { amount: eur(b.rules.minimum) }) : t('account.no_minimum')) + '</p></section>';
      h += '<section class="wsl-card"><h2>' + esc(t('account.addresses')) + '</h2>' + (b.addresses || []).map(function (a) { return '<p>' + esc(a.label) + '</p>'; }).join('') + '</section>';
      h += invoiceEmailsHtml();
      h += '<section class="wsl-card"><p>' + esc(t('account.change')) + '</p>' +
        (contact.email ? '<a class="wsl-btn" href="mailto:' + esc(contact.email) + '">' + esc(contact.email) + '</a>' : '') +
        (contact.phone ? '<a class="wsl-btn" href="tel:' + esc(contact.phone.replace(/[^+\d]/g, '')) + '">' + esc(contact.phone) + '</a>' : '') + '</section>';
      // the language is the address: /nl/ Dutch, anything else English (WS-1); the page is in en and nl only
      var path = location.pathname.replace(/^\/(nl|el|en)(?=\/|$)/, '') || '/';
      var lang = function (code, label) { var on = LOC === code; return '<a class="wsl-btn' + (on ? ' wsl-btn--line' : '') + '" lang="' + code + '" hreflang="' + code + '"' + (on ? ' aria-current="true"' : '') + ' href="' + esc((code === 'nl' ? '/nl' + path : path) + location.search + '#account') + '">' + label + '</a>'; };
      h += '<section class="wsl-card"><h2>' + esc(t('account.language')) + '</h2><div class="wsl-langs">' + lang('en', 'English') + lang('nl', 'Nederlands') + '</div></section>';
      h += installHtml('account');
      h += '<a class="wsl-btn" href="' + esc(root.dataset.logout) + '" data-act="logout">' + esc(t('account.logout')) + '</a>';
      return h + '</div>';
    }
    // Invoice email addresses (owner, 2026-10-15): extra addresses, such as the accountant, that get every invoice and
    // credit note and nothing else. Added and removed here, each change saved at once (the core checks them again).
    // the core's own pattern (invoice_emails.ts): no leading, trailing or double dot, a real domain
    var IE_MAX = 5, IE_EMAIL = /^[^@\s,;<>"'()[\]\\.]+(?:\.[^@\s,;<>"'()[\]\\.]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z]{2,}$/i;
    function invoiceEmailsHtml() {
      var c = S.b.customer, list = c.invoiceEmails || [];
      return '<section class="wsl-card"><h2 id="wsl-ie-h" tabindex="-1">' + esc(t('account.invoice_emails')) + '</h2>' +
        '<p>' + esc(t('account.invoice_emails_text', { email: c.email })) + '</p>' +
        (list.length ? '<ul class="wsl-ie">' + list.map(function (e) {
          return '<li><span>' + esc(e) + '</span><button type="button" class="wsl-btn" data-act="ie-remove" data-val="' + esc(e) + '" aria-label="' + esc(t('account.invoice_email_remove_named', { email: e })) + '">' + esc(t('account.invoice_email_remove')) + '</button></li>';
        }).join('') + '</ul>' : '') +
        (list.length < IE_MAX
          ? '<div class="wsl-ie__add"><label class="wsl-field" for="wsl-ie-new"><span>' + esc(t('account.invoice_email_label')) + '</span><input id="wsl-ie-new" type="email" inputmode="email" autocomplete="off" autocapitalize="off" spellcheck="false" maxlength="254" aria-describedby="wsl-ie-err" value="' + esc(S.ieDraft || '') + '"></label>' +
            '<button type="button" class="wsl-btn wsl-btn--line" data-act="ie-add">' + esc(t('account.invoice_email_add')) + '</button></div>'
          : '<p class="wsl-row__sub" style="font-size:13px">' + esc(t('account.invoice_email_max', { n: IE_MAX })) + '</p>') +
        '<p class="wsl-field__err" id="wsl-ie-err" role="alert"></p></section>';
    }
    function ieError(key, field) {
      var msg = document.getElementById('wsl-ie-err');
      if (msg) msg.textContent = t(key, { n: IE_MAX });
      if (field) { field.setAttribute('aria-invalid', 'true'); field.focus(); }
    }
    function addInvoiceEmail() {
      var input = document.getElementById('wsl-ie-new');
      if (!input || S.ieSaving) return;
      var e = input.value.trim().toLowerCase(), list = (S.b.customer.invoiceEmails || []).slice();
      input.removeAttribute('aria-invalid'); ieError('');
      if (!IE_EMAIL.test(e) || e.length > 254) return ieError('account.invoice_email_invalid', input);
      if (list.indexOf(e) >= 0 || e === String(S.b.customer.email || '').toLowerCase()) return ieError('account.invoice_email_dup', input);
      if (list.length >= IE_MAX) return ieError('account.invoice_email_max', input);
      saveInvoiceEmails({ add: e }, input);
    }
    // one address added or taken off: the core applies it to the list as it is now (staff or another device may have
    // changed it since this page loaded) and answers the whole list
    async function saveInvoiceEmails(change, field) {
      if (S.ieSaving) return;
      S.ieSaving = true;
      root.querySelectorAll('[data-act^="ie-"]').forEach(function (x) { x.disabled = true; });
      try {
        var r = await api('invoice-emails', change);
        if (!r.ok) return ieError(r.code === 'too_many' ? 'account.invoice_email_max' : r.code === 'invalid' ? 'account.invoice_email_invalid' : 'account.invoice_email_failed', field);
        S.b.customer.invoiceEmails = r.invoiceEmails || [];
        S.ieSavedAt = Date.now();
        if (change.add) S.ieDraft = '';
        bootCache.write(S.b);
        if (S.screen === 'account') paintMain();
        toast(t('account.invoice_email_saved'));
        var next = document.getElementById('wsl-ie-new') || document.getElementById('wsl-ie-h'); // the next address, else the card
        if (next) next.focus();
      } catch (e) {
        ieError('', null);
        var msg = document.getElementById('wsl-ie-err');
        if (msg) msg.textContent = e.message || t('account.invoice_email_failed');
      } finally {
        S.ieSaving = false;
        root.querySelectorAll('[data-act^="ie-"]').forEach(function (x) { x.disabled = false; });
      }
    }
    function doneHtml() {
      var d = S.done || {};
      var title = d.status === 'checkout' ? t('done.pay_title') : d.status === 'completed' ? t('done.confirmed_title') : t('done.received_title');
      var text = d.status === 'checkout' ? t('done.pay_text') : d.status === 'completed' ? t('done.confirmed_text', { name: d.name || '', date: d.date ? day(d.date, true) : '' }) : t('done.received_text', { date: d.date ? day(d.date, true) : '' });
      return '<div class="wsl-done" role="status"><div class="wsl-done__icon">' + ICON.check + '</div><h1 tabindex="-1" id="wsl-done-h">' + esc(title) + '</h1><p>' + esc(text) + '</p>' +
        (d.total != null ? (d.totalEx != null
          ? '<p><b>' + esc(t('review.total_ex')) + ': ' + esc(eur(d.totalEx)) + '</b><br><small style="color:var(--wsl-muted)">' + esc(t('review.total')) + ': ' + esc(eur(d.total)) + '</small></p>'
          : '<p><b>' + esc(t('review.total')) + ': ' + esc(eur(d.total)) + '</b></p>') : '') +
        (d.status === 'checkout' && d.url ? '<a class="wsl-btn wsl-btn--primary wsl-btn--wide" href="' + esc(d.url) + '">' + esc(t('done.pay_button')) + '</a>' : '') +
        '<button type="button" class="wsl-btn wsl-btn--wide" data-act="tab" data-val="list">' + esc(t('done.back')) + '</button></div>';
    }

    // ----------------------------------------------------- fills and dialogs ---
    // The message after a fill (owner, 2026-10-11): counts only, a B2B order has hundreds of products; not red, nothing went wrong.
    async function applyFill(r) {
      var msgs = [t(r.lines.length === 1 ? 'fill.done_one' : 'fill.done', { n: r.lines.length })];
      var adj = (r.adjusted || []).length, sk = (r.skipped || []).length;
      if (adj) msgs.push(t(adj === 1 ? 'fill.adjusted_one' : 'fill.adjusted', { n: adj }));
      if (sk) msgs.push(t(sk === 1 ? 'fill.skipped_one' : 'fill.skipped_n', { n: sk }));
      await load();
      go('list');
      toast(msgs.join(' · '), false);
    }
    async function orderAgain(orderId, mode, only) {
      await flush();
      var r = await api('basket/again', only ? { orderId: orderId, mode: mode, only: only } : { orderId: orderId, mode: mode });
      await applyFill(r);
    }
    // The order already holds products: replace them, or add the old order to them.
    // only: the variants ticked in the order's window (linesDialog); every product of the order without it
    function askAgain(orderId, done, only) {
      if (!S.basket.size) { orderAgain(orderId, 'replace', only).then(done, function (e) { toast(e.message, true); done(); }); return; }
      var d = dialog(t('fill.ask_title'), '<p>' + esc(t(S.basket.size === 1 ? 'fill.ask_text_one' : 'fill.ask_text', { n: S.basket.size })) + '</p>' +
        '<button type="button" class="wsl-btn wsl-btn--primary" data-mode="add">' + esc(t('fill.ask_add')) + '</button>' +
        '<button type="button" class="wsl-btn" data-mode="replace">' + esc(t('fill.ask_replace')) + '</button>');
      d.addEventListener('close', done);
      d.querySelectorAll('[data-mode]').forEach(function (b) {
        b.addEventListener('click', function () {
          d.querySelectorAll('[data-mode]').forEach(function (x) { x.disabled = true; });
          orderAgain(orderId, b.getAttribute('data-mode'), only).then(function () { d.close(); }, function (e) { d.close(); toast(e.message, true); });
        });
      });
    }
    // Ordering a past order again (owner, 2026-10-11): one window. With products in the order already, step 1 asks to add
    // to them or replace them; step 2 (at once when the order is empty) lists the order's products with a tick box each (a
    // custom line, with no product in the shop, has none), Select all / none, Back to step 1, and the button that adds the
    // ticked ones with that order's quantities. An order that cannot be ordered again only shows its products.
    function linesDialog(orderId, done) {
      var x = (S.orders && S.orders.orders || []).filter(function (o) { return o.id === orderId; })[0];
      if (!x || !x.lines) { if (done) done(); return; }
      var can = !x.draft && x.state !== 'cancelled' && x.state !== 'received' && x.state !== 'to_pay';
      var mode = S.basket.size ? null : 'replace', picks = null; // picks: what was ticked, kept over Back
      var d = dialog(x.name + ' · ' + day(x.at), '');
      var body = d.querySelector('.wsl-dialog__body');
      if (done) d.addEventListener('close', done);
      function clear() { Array.prototype.slice.call(body.querySelectorAll('.wsl-dialog__step')).forEach(function (e) { e.remove(); }); }
      function stepAsk() {
        clear();
        body.insertAdjacentHTML('beforeend', '<div class="wsl-dialog__step"><p>' + esc(t(S.basket.size === 1 ? 'fill.ask_text_one' : 'fill.ask_text', { n: S.basket.size })) + '</p>' +
          '<button type="button" class="wsl-btn wsl-btn--primary" data-mode="add">' + esc(t('fill.ask_add')) + '</button>' +
          '<button type="button" class="wsl-btn" data-mode="replace">' + esc(t('fill.ask_replace')) + '</button></div>');
        Array.prototype.slice.call(body.querySelectorAll('[data-mode]')).forEach(function (b) { b.addEventListener('click', function () { mode = b.getAttribute('data-mode'); stepPick(); }); });
      }
      function stepPick() {
        clear();
        var rows = x.lines.map(function (l) {
          var qty = '<b>' + esc(String(l.q)) + ' ×</b> ' + esc(l.t);
          return can && l.v ? '<label class="wsl-lines__row"><input type="checkbox" data-pick="' + esc(l.v) + '"' + (!picks || picks.indexOf(l.v) >= 0 ? ' checked' : '') + '><span>' + qty + '</span></label>'
            : '<p class="wsl-lines__row' + (can ? ' wsl-lines__row--off' : '') + '"><span>' + qty + '</span></p>';
        }).join('');
        var back = can && S.basket.size ? '<button type="button" class="wsl-linkbtn" data-back>' + ICON.back + '<span>' + esc(t(mode === 'add' ? 'fill.ask_add' : 'fill.ask_replace')) + '</span></button>' : '';
        var tools = can ? '<div class="wsl-lines__tools">' + back + '<span class="wsl-lines__pick"><button type="button" class="wsl-linkbtn" data-all="1">' + esc(t('orders.pick_all')) + '</button><button type="button" class="wsl-linkbtn" data-all="0">' + esc(t('orders.pick_none')) + '</button></span></div>' : '';
        body.insertAdjacentHTML('beforeend', '<div class="wsl-dialog__step">' + tools + '<div class="wsl-lines">' + rows + '</div>' + (can ? '<button type="button" class="wsl-btn wsl-btn--primary" data-add></button>' : '') + '</div>');
        if (!can) return;
        var boxes = Array.prototype.slice.call(body.querySelectorAll('[data-pick]')), add = body.querySelector('[data-add]');
        function picked() { return boxes.filter(function (b) { return b.checked; }).map(function (b) { return b.getAttribute('data-pick'); }); }
        function paint() { var n = picked().length; add.textContent = t('orders.pick_add', { n: n }); add.disabled = !n; }
        boxes.forEach(function (b) { b.addEventListener('change', paint); });
        Array.prototype.slice.call(body.querySelectorAll('[data-all]')).forEach(function (b) { b.addEventListener('click', function () { var on = b.getAttribute('data-all') === '1'; boxes.forEach(function (c) { c.checked = on; }); paint(); }); });
        var bk = body.querySelector('[data-back]');
        if (bk) bk.addEventListener('click', function () { picks = picked(); stepAsk(); });
        add.addEventListener('click', function () {
          var only = picked();
          if (!only.length) return;
          add.disabled = true;
          orderAgain(orderId, mode, only.length === boxes.length ? null : only).then(function () { d.close(); }, function (e) { d.close(); toast(e.message, true); });
        });
        paint();
      }
      if (mode) stepPick(); else stepAsk();
    }
    function dialog(title, body) {
      var d = document.createElement('dialog');
      d.className = 'wsl-dialog';
      d.setAttribute('aria-label', title);
      d.innerHTML = '<div class="wsl-dialog__body"><div class="wsl-dialog__head"><h2>' + esc(title) + '</h2><button type="button" class="wsl-icon-btn" style="border:0" data-close aria-label="' + esc(t('close')) + '">' + ICON.close + '</button></div>' + body + '</div>';
      root.appendChild(d); // inside .wsl: its colours, fonts and focus rings
      d.addEventListener('close', function () { d.remove(); });
      d.querySelector('[data-close]').addEventListener('click', function () { d.close(); });
      d.showModal();
      return d;
    }
    // A product's details (owner, 2026-10-09): the card keeps the image, name and the prices ex VAT; the rest is here,
    // with a bigger image. Its buttons act on the card behind (the page's click handler), then the details close.
    function infoDialog(v) {
      var it = S.items.get(v);
      if (!it) return;
      var kv = [];
      function row(k, val) { var lines = [].concat(val).filter(Boolean); if (lines.length) kv.push('<dt>' + esc(t(k)) + '</dt><dd>' + lines.map(esc).join('<br>') + '</dd>'); }
      function both(piece, box) { return [eur(piece) + ' ' + t('item.per_piece'), it.box > 1 ? eur(box) + ' ' + t('item.per_box_of', { n: it.box }) : '']; }
      row('info.brand', it.vendor);
      row('item.sku', it.s);
      row('info.barcode', it.b);
      row('info.storage', it.temp ? t('temp.' + it.temp) : '');
      if (it.vat) row('info.price_ex', both(it.x, lineEx(it, it.box)));
      row('info.price_incl', both(it.c, it.c * it.box));
      if (it.r && it.r > it.c) row('info.retail', eur(it.r) + ' ' + t('item.incl'));
      row('info.stock', soldOut(it) ? t('item.sold_out') : showStock() && it.max != null ? it.max + ' ' + unitWord(it, it.max, false) : '');
      if (it.last) row('info.last', qtyText(it, it.last.q) + ' · ' + day(it.last.d));
      var on = S.onList.has(v);
      var body = (it.img ? '<img class="wsl-info__img" src="' + esc(imgAt(it.img, 800)) + '" alt="">' : '') + '<dl class="wsl-kv">' + kv.join('') + '</dl>' +
        (it.last && !soldOut(it) ? '<button type="button" class="wsl-btn wsl-btn--primary" data-act="last" data-v="' + esc(v) + '">' + esc(t('info.again', { qty: qtyText(it, it.last.q) })) + '</button>' : '') +
        '<button type="button" class="wsl-btn wsl-btn--line" data-act="mark" data-v="' + esc(v) + '">' + ICON.mark(on) + esc(t(on ? 'info.list_remove' : 'info.list_add')) + '</button>';
      var d = dialog(it.t, body);
      d.addEventListener('click', function (ev) { if (ev.target.closest('[data-act="last"], [data-act="mark"]')) setTimeout(function () { d.close(); }, 0); });
    }
    // CU-9 (owner, 2026-10-09): change one of the customer's addresses, or add a delivery address. Netherlands only;
    // the core checks it (postcode, required fields) and saves it in Shopify. The company address keeps its name.
    var ADDR_ERR = { required: 'address.err_required', postcode: 'address.err_postcode' };
    function addressDialog(id) {
      var a = id ? (S.b.addresses || []).filter(function (x) { return x.id === id; })[0] : null;
      if (id && !a) return;
      function f(k, label, val, attrs) {
        return '<label class="wsl-field" for="wsl-af-' + k + '"><span>' + esc(label) + '</span><input id="wsl-af-' + k + '" data-ak="' + k + '" value="' + esc(val || '') + '" aria-describedby="wsl-af-' + k + '-err" ' + attrs + '>' +
          '<span class="wsl-field__err" id="wsl-af-' + k + '-err"></span></label>';
      }
      var d = dialog(t(a ? 'address.title_edit' : 'address.title_add'),
        (a && a.def ? '<p class="wsl-row__sub" style="font-size:13px">' + esc(t('address.default_note')) + '</p>' : f('company', t('address.name'), a ? a.company : '', 'autocomplete="organization" maxlength="120"')) +
        f('address1', t('address.street'), a ? a.address1 : '', 'autocomplete="address-line1" maxlength="120"') +
        f('address2', t('address.addition'), a ? a.address2 : '', 'autocomplete="address-line2" maxlength="120"') +
        '<div class="wsl-form__grid">' + f('zip', t('address.zip'), a ? a.zip : '', 'autocomplete="postal-code" maxlength="7" autocapitalize="characters"') +
        f('city', t('address.city'), a ? a.city : '', 'autocomplete="address-level2" maxlength="60"') + '</div>' +
        '<p class="wsl-row__sub" style="font-size:13px">' + esc(t('address.nl_only')) + '</p><p class="wsl-field__err" id="wsl-af-err" role="alert"></p>' +
        '<button type="button" class="wsl-btn wsl-btn--primary" data-save>' + esc(t('address.save')) + '</button>');
      var btn = d.querySelector('[data-save]'), msg = d.querySelector('#wsl-af-err');
      d.querySelector('[data-ak]').focus(); // a form opened on purpose: straight to its first field
      btn.addEventListener('click', async function () {
        if (btn.disabled) return;
        btn.disabled = true; msg.textContent = '';
        var raw = {};
        d.querySelectorAll('[data-ak]').forEach(function (i) { raw[i.getAttribute('data-ak')] = i.value; i.removeAttribute('aria-invalid'); document.getElementById(i.id + '-err').textContent = ''; });
        if (a) raw.addressId = a.id;
        try {
          var r = await api('address/save', raw);
          if (!r.ok) {
            Object.keys(r.errors || {}).forEach(function (k) {
              var i = d.querySelector('#wsl-af-' + k);
              if (!i) return;
              i.setAttribute('aria-invalid', 'true');
              document.getElementById(i.id + '-err').textContent = t(ADDR_ERR[r.errors[k]] || 'address.err_required');
            });
            var first = d.querySelector('[aria-invalid="true"]'); // the first in the form, not in the answer
            if (first) first.focus();
            else msg.textContent = t(r.code === 'too_many' ? 'address.too_many' : 'address.not_saved');
            return;
          }
          S.b.addresses = r.addresses || S.b.addresses; S.b.defaultAddressId = r.defaultId || S.b.defaultAddressId;
          if (r.addressId && !a) S.addressId = r.addressId; // a new address is the one this order goes to; a change keeps the choice
          d.close();
          paintMain(); paintFoot();
          saveMeta().catch(metaFailed);
          toast(t('address.saved'));
          var again = root.querySelector('input[name="wsl-addr"]:checked');
          if (again) again.focus();
        } catch (e) {
          msg.textContent = e.message || t('address.not_saved');
        } finally { btn.disabled = false; }
      });
    }
    // WS-2: barcode scan with the browser's BarcodeDetector; elsewhere a camera fallback
    // library from jsDelivr; always a field to type the code.
    function scanDialog() {
      var d = dialog(t('scan.title'), '<video class="wsl-video" playsinline muted aria-hidden="true"></video><p class="wsl-field__err" id="wsl-scan-msg" role="status"></p>' +
        '<form class="wsl-search" id="wsl-scan-form"><label>' + ICON.search + '<span class="wsl-sr">' + esc(t('scan.manual')) + '</span><input id="wsl-scan-code" inputmode="numeric" autocomplete="off" placeholder="' + esc(t('scan.manual')) + '"></label><button class="wsl-btn wsl-btn--primary" type="submit">' + esc(t('scan.find')) + '</button></form>');
      var video = d.querySelector('video'), msg = d.querySelector('#wsl-scan-msg'), stream = null, stop = false, controls = null;
      function camOff() {
        if (stream) stream.getTracks().forEach(function (x) { x.stop(); });
        if (controls && controls.stop) controls.stop();
        if (video.srcObject && video.srcObject.getTracks) video.srcObject.getTracks().forEach(function (x) { x.stop(); });
      }
      d.addEventListener('close', function () { stop = true; camOff(); });
      async function found(code) {
        stop = true;
        camOff();
        var cat;
        try { cat = await loadCatalogue(); } catch (e) { msg.textContent = e.message; return; }
        var it = cat.items.find(function (i) { return i.b && i.b === code; });
        if (!it) { msg.textContent = t('scan.not_found', { code: code }); stop = false; return; }
        d.close();
        S.catQ = code; S.aisle = null; S.flash = it.v;
        go('catalogue');
      }
      d.querySelector('#wsl-scan-form').addEventListener('submit', function (ev) {
        ev.preventDefault();
        var code = d.querySelector('#wsl-scan-code').value.replace(/\D/g, '');
        if (code) found(code);
      });
      (async function () {
        try {
          if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) throw new Error('no camera');
          if ('BarcodeDetector' in window) {
            stream = await navigator.mediaDevices.getUserMedia({ video: { facingMode: 'environment' } });
            if (stop) { camOff(); return; } // closed while the camera was starting
            video.srcObject = stream; await video.play();
            var det = new window.BarcodeDetector({ formats: ['ean_13', 'ean_8', 'upc_a', 'upc_e', 'code_128'] });
            var tick = async function () {
              if (stop) return;
              try { var codes = await det.detect(video); if (codes.length) { found(codes[0].rawValue); return; } } catch (e) { /* next frame */ }
              setTimeout(tick, 250);
            };
            tick();
          } else {
            await new Promise(function (ok, bad) {
              if (window.ZXingBrowser) return ok();
              var s = document.createElement('script');
              s.src = 'https://cdn.jsdelivr.net/npm/@zxing/browser@0.1.5/umd/zxing-browser.min.js';
              s.onload = ok; s.onerror = bad; document.head.appendChild(s);
            });
            if (stop) return;
            var reader = new window.ZXingBrowser.BrowserMultiFormatReader();
            controls = await reader.decodeFromVideoDevice(undefined, video, function (res) { if (res && !stop) found(res.getText()); });
            if (stop) camOff();
          }
        } catch (e) {
          video.hidden = true;
          msg.textContent = t('scan.no_camera');
          d.querySelector('#wsl-scan-code').focus();
        }
      })();
    }
    var toastTimer = null;
    function toast(text, bad) {
      var old = document.querySelector('.wsl-toast');
      if (old) old.remove();
      var el = document.createElement('div');
      el.className = 'wsl-toast' + (bad ? ' wsl-toast--bad' : '');
      el.setAttribute('role', bad ? 'alert' : 'status');
      el.textContent = text;
      root.appendChild(el);
      clearTimeout(toastTimer);
      toastTimer = setTimeout(function () { el.remove(); }, bad ? 7000 : 4000);
    }

    // ------------------------------------------------------------- navigation ---
    function go(screen) {
      S.screen = screen;
      if (screen === 'orders') S.orders = null; // fresh each time
      paintMain(); paintFoot();
      window.scrollTo(0, 0);
      var h = document.getElementById('wsl-done-h');
      if (h) h.focus();
      try { history.replaceState(null, '', '#' + screen); } catch (e) { /* ignore */ }
    }

    root.addEventListener('click', function (ev) {
      var el = ev.target.closest('[data-act]');
      if (!el) {
        // a tap on a product card outside its controls: the product's details
        var card = ev.target.closest('.wsl-row');
        if (card && root.contains(card) && !ev.target.closest('.wsl-row__act')) infoDialog(card.getAttribute('data-row'));
        return;
      }
      if (!root.contains(el) || el.disabled) return;
      var act = el.getAttribute('data-act'), v = el.getAttribute('data-v'), val = el.getAttribute('data-val');
      var it = v && S.items.get(v);
      if (act === 'inc' && it) { setQty(v, (S.basket.get(v) || 0) + step(it)); sayQty(it); }
      else if (act === 'dec' && it) { setQty(v, (S.basket.get(v) || 0) - step(it)); sayQty(it); }
      else if (act === 'last' && it && it.last) { if (it.box > 1) S.unit.set(v, it.last.q % it.box ? 'piece' : 'box'); setQty(v, it.last.q); sayQty(it); }
      else if (act === 'unit' && it) {
        // to boxes: a quantity that is not whole boxes goes up to the next box (setQty, within stock)
        S.unit.set(v, val === 'piece' ? 'piece' : 'box');
        if (S.basket.get(v)) setQty(v, S.basket.get(v)); else { paintItem(v); paintFoot(); }
        say(t(val === 'piece' ? 'item.unit_pieces' : 'item.unit_boxes'));
      }
      else if (act === 'remove') { setQty(v, 0); paintMain(); paintFoot(); }
      else if (act === 'drop') {
        el.disabled = true;
        api('basket/line', { variantId: v, quantity: 0 }).then(function () {
          S.b.gone = (S.b.gone || []).filter(function (g) { return g.v !== v; });
          S.basket.delete(v); S.saved.delete(v); paintMain(); paintFoot();
        }).catch(function (e) { el.disabled = false; toast(e.message, true); });
      }
      else if (act === 'mark' && v) toggleList(v);
      else if (act === 'info' && v) infoDialog(v);
      else if (act === 'addr-edit' || act === 'addr-add') addressDialog(act === 'addr-edit' ? val : null);
      else if (act === 'ie-add') addInvoiceEmail();
      else if (act === 'ie-remove' && val) saveInvoiceEmails({ remove: val }, null);
      else if (act === 'soldout') {
        S.hideOut = !S.hideOut;
        try { localStorage.setItem(HIDE_STORE, S.hideOut ? '1' : '0'); } catch (e) { /* kept for this visit only */ }
        keepFocus(paintRows, el);
      }
      else if (act === 'tab') { if (val === 'list' && S.screen === 'done') load().then(function () { go('list'); }).catch(function (e) { toast(e.message, true); }); else keepFocus(function () { go(val); }, el); }
      else if (act === 'temp') keepFocus(function () { S.temp = val; paintMain(); }, el);
      else if (act === 'aisle') keepFocus(function () { S.aisle = val || null; S.catShown = 60; paintMain(); }, el);
      else if (act === 'more') {
        var k = focusKey(el), shown = S.catShown;
        S.catShown += 60; paintRows();
        if (!refocus(k)) { // all shown: the first new product
          var first = root.querySelectorAll('#wsl-rows .wsl-row')[shown], b = first && first.querySelector('button:not([disabled])');
          if (b) b.focus({ preventScroll: true });
        }
      }
      else if (act === 'review') { S.errors = null; S.saveFailed = false; go('review'); }
      // the cart button opens the cart, and closes it again when it is open (owner, 2026-10-12): back to the screen before
      else if (act === 'logout') bootCache.clear(); // the link itself logs out
      else if (act === 'home') { ev.preventDefault(); if (S.screen === 'done') load().then(function () { go('list'); }).catch(function (e) { toast(e.message, true); }); else go('list'); }
      else if (act === 'cart') { if (S.screen === 'review') go(S.beforeCart || 'list'); else { S.beforeCart = S.screen; S.errors = null; S.saveFailed = false; go('review'); } }
      else if (act === 'install') {
        var pe = window.__wslInstall;
        if (!pe) { installChanged(); return; }
        window.__wslInstall = null; // the event answers once
        try { pe.prompt(); } catch (e) { installChanged(); return; }
        Promise.resolve(pe.userChoice).then(function (r) { hideInstall(r && r.outcome === 'accepted' ? 3650 : 7); installChanged(); }, function () { installChanged(); });
      }
      else if (act === 'install-hide') { hideInstall(30); installChanged(); }
      else if (act === 'back') go('list');
      else if (act === 'date') { S.date = val; keepFocus(function () { render(); go('review'); }, el); saveMeta().catch(metaFailed); }
      else if (act === 'place') place();
      else if (act === 'again') { // the order's products, tick what to order again (owner, 2026-10-11); the orders are read first when the tab was not opened yet
        var oid = el.getAttribute('data-order');
        el.disabled = true;
        var openAgain = function () {
          var has = S.orders && S.orders.orders.some(function (o) { return o.id === oid && o.lines && o.lines.length; });
          if (has) linesDialog(oid, function () { el.disabled = false; }); else askAgain(oid, function () { el.disabled = false; });
        };
        if (S.orders) openAgain(); else api('orders').then(function (o) { S.orders = o; openAgain(); }, openAgain);
      }
      else if (act === 'lines') linesDialog(el.getAttribute('data-order'));
      else if (act === 'scan') scanDialog();
    });
    var searchTimer = null;
    root.addEventListener('input', function (ev) {
      var id = ev.target.id;
      if (id === 'wsl-q' || id === 'wsl-cq') {
        clearTimeout(searchTimer);
        searchTimer = setTimeout(function () {
          if (id === 'wsl-q') S.q = ev.target.value.trim(); else { S.catQ = ev.target.value.trim(); S.catShown = 60; }
          paintRows();
        }, 180);
      } else if (id === 'wsl-ie-new') {
        S.ieDraft = ev.target.value; // kept when the screen is drawn again (the fresh start-up answer, a refresh)
      } else if (id === 'wsl-note') {
        S.note = ev.target.value;
        clearTimeout(metaTimer);
        metaTimer = setTimeout(function () { saveMeta().catch(metaFailed); }, 800);
      }
    });
    // A typed quantity counts in what the card shows (boxes or pieces) and is saved like a tap: within stock,
    // whole boxes. Saved on Enter or on leaving the field; an emptied field keeps the quantity it had.
    function typedQty(el) {
      var v = el.getAttribute('data-v'), it = S.items.get(v);
      if (!it) return;
      var digits = el.value.replace(/\D/g, '');
      if (digits === '') { el.value = boxes(it, S.basket.get(v) || 0); return; }
      var want = Number(digits) * step(it);
      if (want === (S.basket.get(v) || 0)) { el.value = boxes(it, want); return; }
      // once per field: the repaint removes it while it has focus, and Chrome then sends its change again
      if (el.getAttribute('data-done')) return;
      el.setAttribute('data-done', '1');
      setQty(v, want);
      var got = S.basket.get(v) || 0;
      if (got < want) toast(t('errors.over_stock', { name: it.t, max: qtyText(it, got) }), true);
      else sayQty(it);
    }
    root.addEventListener('keydown', function (ev) {
      if (ev.key === 'Enter' && ev.target.getAttribute && ev.target.getAttribute('data-act') === 'qty') { ev.preventDefault(); typedQty(ev.target); }
      else if (ev.key === 'Enter' && ev.target.id === 'wsl-ie-new') { ev.preventDefault(); addInvoiceEmail(); }
    });
    // the whole number selected, so typing replaces it
    root.addEventListener('focusin', function (ev) {
      var el = ev.target;
      if (el.getAttribute && el.getAttribute('data-act') === 'qty') setTimeout(function () { try { if (document.activeElement === el) el.select(); } catch (e) { /* not selectable */ } }, 0);
    });
    root.addEventListener('change', function (ev) {
      // on leaving the field: after the focus has moved (Tab to +), so the repaint keeps it there
      if (ev.target.getAttribute('data-act') === 'qty') { var qel = ev.target; setTimeout(function () { typedQty(qel); }, 0); }
      else if (ev.target.id === 'wsl-aisle') { S.listAisle = ev.target.value || null; keepFocus(paintMain, ev.target); }
      else if (ev.target.id === 'wsl-more-dates') { S.date = ev.target.value; keepFocus(function () { render(); go('review'); }); saveMeta().catch(metaFailed); }
      else if (ev.target.name === 'wsl-addr') { S.addressId = ev.target.value; saveMeta().catch(metaFailed); }
    });
    function sayQty(it) { var n = boxes(it, S.basket.get(it.v) || 0); say(n + ' ' + unitWord(it, n)); }
    // W9: one request at a time per product; a tap made meanwhile is sent after it (the last tap wins).
    function toggleList(v) {
      if (S.onList.has(v)) S.onList.delete(v); else S.onList.add(v);
      paintItem(v);
      syncMark(v);
    }
    async function syncMark(v) {
      if (S.marking.has(v)) return;
      S.marking.add(v);
      function saved() { return S.b.list.ids.indexOf(v) >= 0; }
      var sent = 0;
      try {
        while (S.onList.has(v) !== saved()) {
          var on = S.onList.has(v);
          sent++;
          await api('orderlist', { variantId: v, on: on });
          if (on && !saved()) S.b.list.ids.push(v);
          if (!on) S.b.list.ids = S.b.list.ids.filter(function (x) { return x !== v; });
        }
        if (sent) toast(t(saved() ? 'item.list_added' : 'item.list_removed'));
        if (sent && S.screen === 'list') paintRows(); // the order list shows the change (the details are closed by then)
      } catch (e) {
        if (saved()) S.onList.add(v); else S.onList.delete(v);
        paintItem(v);
        toast(e.message, true);
      } finally {
        S.marking.delete(v);
      }
    }
    // W8: a closing page runs no more promise callbacks, so a save queued behind one still on
    // its way would never leave: send the quantity now as well (keepalive), and a note just typed.
    function saveNow() {
      var vs = new Set();
      S.timers.forEach(function (tm, v) { clearTimeout(tm); vs.add(v); });
      S.timers.clear();
      S.inflight.forEach(function (p, v) { vs.add(v); });
      vs.forEach(function (v) {
        if (S.inflight.has(v)) call(base, 'basket/line', LOC, { variantId: v, quantity: S.basket.get(v) || 0 }, true).catch(function () {});
        save(v, true); // a page that stays: in tap order, and the result is noted
      });
      if (metaTimer) saveMeta(true).catch(function () {});
    }
    window.addEventListener('pagehide', saveNow);
    // W4: dates, the cut-off and stock move with the clock. Read them again when the cut-off
    // passes, on a new day, when the page comes back after a while, and after a 'date' refusal.
    function stale() {
      var d = S.b && S.b.dates;
      if (!d) return false;
      return !!S.wantRefresh || new Date().toDateString() !== S.loadedDay || (!!d.cutoffMs && Date.now() > d.cutoffMs && S.cutDone !== d.cutoffMs);
    }
    function refreshSoon() { S.wantRefresh = true; refresh(); }
    async function refresh() {
      if (S.refreshing || S.placing || !S.b || root.querySelector('dialog[open]')) { S.wantRefresh = true; return; } // the next minute tries again
      S.refreshing = true;
      var cut = S.b.dates && S.b.dates.cutoffMs;
      try {
        await flush();
        if (metaTimer) await saveMeta().catch(function () {});
        await load();
        S.wantRefresh = false; S.cutDone = cut; // a clock ahead of the core's asks once, not every minute
        var y = window.scrollY;
        keepFocus(render);
        window.scrollTo(0, y);
      } catch (e) {
        S.wantRefresh = true; // offline: the next minute tries again
      } finally {
        S.refreshing = false;
      }
    }
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') saveNow();
      else if (S.b && (Date.now() - S.loadedAt > 5 * 60000 || stale())) refresh();
    });
    window.addEventListener('pageshow', function (ev) { if (ev.persisted && S.b && Date.now() - S.loadedAt > 5 * 60000) refresh(); });
    setInterval(function () {
      if (document.visibilityState !== 'hidden' && stale()) refresh();
    }, 60000);

    // ------------------------------------------------------------------ start ---
    async function start() {
      try {
        var kept = bootCache.read();
        if (kept) { // the last visit at once, the fresh answer behind (the stale check keeps asking if it fails)
          applyBoot(kept.b); S.loadedAt = kept.at;
          var want0 = (location.hash || '').slice(1);
          if (['catalogue', 'orders', 'account'].indexOf(want0) >= 0) S.screen = want0;
          render();
          try { await load(true); var y0 = window.scrollY; keepFocus(render); window.scrollTo(0, y0); } catch (e) { /* the kept page stays; the next minute tries again */ }
          return;
        }
        await load(true);
        var want = (location.hash || '').slice(1);
        if (['catalogue', 'orders', 'account'].indexOf(want) >= 0) S.screen = want;
        try {
          var sp = new URLSearchParams(location.search), pay = sp.get('pay');
          if (pay && ['done', 'cancelled', 'expired', 'nothing', 'unavailable', 'error'].indexOf(pay) >= 0) {
            S.payNote = pay; S.screen = 'orders';
            sp.delete('pay');
            history.replaceState(null, '', location.pathname + (sp.toString() ? '?' + sp : '') + '#orders');
          }
        } catch (e) { /* old browser: no message */ }
        render();
      } catch (e) {
        root.innerHTML = '<div class="wsl-boot" role="alert"><p>' + esc(t('error_load')) + '</p><p style="margin-top:12px"><button type="button" class="wsl-btn" id="wsl-retry">' + esc(t('retry')) + '</button></p></div>';
        document.getElementById('wsl-retry').addEventListener('click', function () { root.innerHTML = '<div class="wsl-boot wsl-boot--skel" role="status" aria-label="' + esc(t('loading')) + '">' + (CFG.logo ? '<img class="wsl-boot__logo" src="' + esc(CFG.logo) + '" alt="" height="40">' : '') + '<div class="wsl-skel wsl-skel--bar"></div>' + '<div class="wsl-skel wsl-skel--row"></div>'.repeat(5) + '</div>'; start(); });
      }
    }
    start();
  }

  var signupEl = document.getElementById('wsl-signup');
  if (signupEl) initSignup(signupEl);
  var appEl = document.getElementById('wsl-app');
  if (appEl) initApp(appEl);
})();
